export default {
  common: { loading: 'Caricamento…', noData: 'Nessun dato', clear: 'Cancella', delete: 'Elimina' },
  errors: { /* notices-i18n */
    generic: 'Qualcosa è andato storto. Riprova.',    codes: {
      // The clock card's refusals (time-api /timer/start and /timer/stop): the card
      // shows the specific reason, as time-ui's own clock button does (issue 700).
      leave_day: 'Questo giorno comprende un’assenza approvata di un giorno intero — non è possibile registrare orario di lavoro.',
      // A person her contract frees from booking working time (issue 981): time-api refuses the clock-in with this code.
      work_time_booking_off: 'Secondo il tuo contratto registri solo il tempo di progetto, non l\'orario di lavoro.',
      week_approved: 'Questa settimana è già approvata e bloccata: modifiche solo con una richiesta di correzione.',
      week_submitted: 'Questa settimana è stata inviata ed è in attesa di decisione: modifiche solo dopo il ritiro o la restituzione.',
      already_clocked_in: "Hai già timbrato l'entrata. Chiudi prima l'orario di lavoro in corso.",
      block_overlap: 'Questo orario di lavoro si sovrappone a un altro.',
      block_locked: 'Questo orario di lavoro è bloccato da una settimana chiusa. Richiedi invece una correzione.',
      // user-api's SSO connection PUT (#882): issuer and client are frozen while SSO is enforced.
      sso_enforced: 'Disattiva «Richiedi l’accesso solo tramite SSO» prima di modificare l’URL dell’emittente o il Client ID.',
      // The SSO connection PUT of user-api (issue 926): a list entry that is not a domain.
      invalid_domain: 'Uno dei domini e-mail non è un dominio. Inserisci domini come example.com, senza caratteri jolly o indirizzi web.',
      // ats-api reports this flat on the envelope; `errorKeyFor` prefers a
      // curated code entry over the status fallback, which is how the custom-field
      // dialog keeps its one specific message without reading the backend string.
      CUSTOM_FIELD_SENSITIVITY_LOCKED: 'Questo campo è dichiarato come categoria particolare e la dichiarazione non può essere ritirata.',
      LEGAL_NOTICE_BLANK_EMPTY: 'Un campo non può essere lasciato vuoto.',
      LEGAL_NOTICE_BLANK_UNKNOWN: 'Questa informativa non ha nessun campo con questo nome.',
      LEGAL_NOTICE_BLANK_TOKEN: 'Un valore non può a sua volta contenere un campo da completare.',
      // The employee-notice gate (issue 576 M3): the invite refusal names WHO
      // can clear it, so an admin sent here knows the fix is not theirs to retry.
      EMPLOYEE_NOTICE_INCOMPLETE: 'Gli inviti sono sospesi finché non vengono completati tutti i campi delle informative per i dipendenti in Note legali. Chiedi al proprietario del workspace, a un\'amministrazione suite o al responsabile della protezione dei dati di completarli.',
      LEGAL_READINESS_UNAVAILABLE: 'Non siamo riusciti a verificare se le informative per i dipendenti sono complete. Riprova tra qualche minuto.',
    } as Record<string, string>,
  },
  billing: {
    title: 'Fatturazione', status: 'Stato', paymentMethod: 'Metodo di pagamento',
    updateCard: 'Sostituisci carta', addCard: 'Aggiungi carta',
    invoices: 'Fatture', charges: 'Pagamenti',
    noInvoices: 'Ancora nessuna fattura.', noCharges: 'Ancora nessun pagamento.',
    noCard: 'Nessuna registrata', validUntil: 'valida fino al {date}',
    trialDaysLeft: '{days} giorni rimanenti di prova', trialExpired: 'Prova scaduta',
    trialDaysLeftUntil: '{days} giorni rimanenti di prova — termina il {date}',
    // A free_months promo account (issue 808): the whole cardless run, never "trial end" at d2.
    trialDaysLeftFree: 'Restano {days} giorni gratuiti — fino al {date}',
    nextChargeOn: 'Prossimo addebito il {date}',
    exempt: { badge: 'Esente da fatturazione', note: 'lumi ha stabilito che questo spazio di lavoro non viene fatturato al momento.' },
    download: 'Scarica', dangerZone: 'Zona pericolosa',
    col: { date: 'Data', period: 'Periodo', net: 'Netto', vat: 'IVA', gross: 'Lordo', status: 'Stato', kind: 'Tipo', amount: 'Importo', document: 'Fattura' },
    statusLabel: { trialing: 'Prova', active: 'Attivo', delinquent: 'Pagamento dovuto', closed: 'Chiuso', canceled: 'Disdetto' },
    tab: { plans: 'Piani', paymentMethod: 'Metodo di pagamento', invoices: 'Fatture e pagamenti', referral: 'Inviti', externalPostings: 'Annunci di lavoro', dangerZone: 'Disdici ed elimina' },
    externalPostings: {
      title: 'Annunci su portali di lavoro esterni',
      intro: 'Gli annunci sui portali di lavoro esterni si ordinano uno alla volta e vengono fatturati per ordine: fino a diverse migliaia di euro ciascuno. Con questa opzione attiva può effettuare questi ordini chi ha nel proprio ruolo di selezione il permesso «Pubblicare all’esterno (a pagamento)» — all’inizio solo gli amministratori della selezione; ogni ordine viene addebitato a questo spazio di lavoro.',
      switchLabel: 'Consenti di ordinare annunci su portali di lavoro esterni',
      saving: 'Salvataggio',
      offHint: 'Disattivandolo fermi solo i nuovi ordini. Gli annunci già online restano attivi e continuano a essere fatturati fino alla fine della loro durata.',
      offHintOpenOrders: 'In questo momento ci sono annunci online. Disattivandolo fermi solo i nuovi ordini: gli annunci in corso restano attivi e continuano a essere fatturati fino alla fine della loro durata.',
      roleNote: 'Solo il proprietario dello spazio di lavoro, un responsabile della fatturazione o un amministratore della suite possono modificare questa impostazione. Chi non deve ordinare annunci si ferma invece nella selezione, revocando dal suo ruolo il permesso «Pubblicare all’esterno (a pagamento)».',
      demoNote: 'Questo è uno spazio di lavoro dimostrativo. Le sue impostazioni vengono sostituite con la configurazione reale, quindi questo interruttore resta bloccato fino ad allora.',
      noCardTitle: 'Nessun metodo di pagamento registrato',
      noCardBody: 'Puoi attivarlo subito, ma un ordine di annuncio potrà essere pagato solo quando è registrata una carta.',
      noCardCta: 'Aggiungi una carta',
      savedOn: 'Gli annunci esterni sono attivi. I recruiter vedranno la sezione di ordine al prossimo caricamento della pagina.',
      savedOff: 'Gli annunci esterni sono disattivati. Non è possibile ordinare nuovi annunci; quelli già online restano attivi e continuano a essere fatturati.',
    },
    invoiceStatus: { draft: 'In preparazione', issued: 'Emessa', sent: 'Inviata', canceled: 'Annullata' },
    chargeKind: { subscription: 'Abbonamento', proration: 'Rateo', posting: 'Annuncio di lavoro', recovery: 'Pagamento di recupero' },
    posting: { orderRef: 'Ordine {ref}', invoice: 'Scarica la fattura' },
    chargeStatus: { created: 'Creato', pending: 'In sospeso', paid: 'Pagato', failed: 'Non riuscito', authorized: 'Bloccato', order_placed: 'Inoltrato', capture_requested: 'Addebito richiesto', captured: 'Pagato', settled: 'Pagato', refunded: 'Rimborsato', chargeback: 'Storno bancario', voided: 'Non riuscito' },
    bill: { label: 'Fattura {number}', labelMany: 'Fatture {number}', unnumbered: 'Fattura in preparazione', paid: 'Pagata', closed: 'Chiusa', retry: 'Nuovo tentativo', projected: 'Prevista' },
    // The promo (issue 808, ADR 0100): one line for the phase the account is in.
    promo: { trial: 'Prova fino al {start} · poi 1 mese gratis fino al {end} · codice {code} | Prova fino al {start} · poi {n} mesi gratis fino al {end} · codice {code}', run: 'Mesi gratis fino al {end} · codice {code}', discount: 'Prova fino al {start} · poi 1 mese con il {percent} % di sconto su posti e moduli · codice {code} | Prova fino al {start} · poi {n} mesi con il {percent} % di sconto su posti e moduli · codice {code}', discountRun: '{percent} % di sconto su posti e moduli fino al {end} · codice {code}', invoiceLine: 'Codice promozionale {code} −{percent} %', referralLine: 'Bonus invito −{percent} %', referralLineCapped: 'Bonus invito −{percent} % (con tetto)' },
    // A module code typed in the add-module dialog (issue 1029, M2).
    modulePromo: { label: 'Codice promozionale (facoltativo)', apply: 'Applica', remove: 'Rimuovi', applied: '{code}: {percent} % di sconto su {module} per 1 fattura | {code}: {percent} % di sconto su {module} per {n} fatture', savesToday: 'Il codice toglie {amount} dall\'addebito di oggi.', rateLimited: 'Troppi tentativi. Aspetta qualche minuto e riprova.', checkFailed: 'Al momento il codice non può essere verificato. Puoi aggiungere il modulo anche senza.', notBooked: 'Non è stato prenotato nulla: puoi aggiungere il modulo senza il codice.', addedWithoutDiscount: 'Il codice non ha potuto essere applicato, quindi non c\'è nessuno sconto.', module: { time_tracking: 'Rilevazione presenze' }, trimmed: '{code} dà il {percent} %, ma la tua fattura ha già uno sconto – su {module} ottieni il {effective} % (tutti gli sconti di una fattura hanno un tetto).', trimmedNothing: '{code} dà il {percent} %, ma la tua fattura ha già uno sconto – per ora questo codice non aggiunge nulla.', pending: 'Stiamo ancora confermando il tuo codice – comparirà sulla prossima fattura una volta confermato.', invoiceLine: 'Codice promozionale {code} −{percent} % ({module})', running: '{code}: {percent} % di sconto su 1 fattura ancora | {code}: {percent} % di sconto su altre {n} fatture', reason: { unknown: 'Non conosciamo questo codice. Controlla come è scritto.', disabled: 'Questo codice è stato disattivato.', notYetValid: 'Questo codice non è ancora valido.', expired: 'Questo codice è scaduto.', exhausted: 'Hai già usato questo codice, oppure è esaurito.', moduleNotEligible: 'Questo codice non copre {module}.', wrongCheckout: 'Questo codice è per le nuove registrazioni, non per aggiungere un modulo.', unavailable: 'Questo codice non può essere usato qui.' } },
    // The billing door (issue 824): a promo code entered on a running workspace.
    // The workspace's own referral code (issue 824), shown to those who manage billing.
    referral: { title: 'Il tuo codice di invito', copy: 'Copia codice', copyLink: 'Copia link del checkout', copied: 'Codice di invito copiato', linkCopied: 'Link del checkout copiato', friendGets: 'Chi usa il tuo codice ottiene il {percent} % di sconto sul primo mese pagato. | Chi usa il tuo codice ottiene il {percent} % di sconto sui primi {n} mesi pagati.', youGet: 'Per ogni azienda che inizia a pagare con il tuo codice: {percent} % di sconto su una delle tue fatture — più bonus si sommano, fino al {ceiling} % per fattura. | Per ogni azienda che inizia a pagare con il tuo codice: {percent} % di sconto su {n} delle tue fatture — più bonus si sommano, fino al {ceiling} % per fattura.', youGetCapped: 'Per ogni azienda che inizia a pagare con il tuo codice: {percent} % di sconto su una delle tue fatture — più bonus si sommano, fino al {ceiling} % per fattura; ogni bonus toglie al massimo {cap} per fattura. | Per ogni azienda che inizia a pagare con il tuo codice: {percent} % di sconto su {n} delle tue fatture — più bonus si sommano, fino al {ceiling} % per fattura; ogni bonus toglie al massimo {cap} per fattura.', paused: 'Il tuo codice è in pausa finché per il tuo spazio di lavoro è aperta una richiesta di eliminazione. Torna a funzionare appena viene ritirata.', disabled: 'Questo codice è stato disattivato e non può più essere usato.', none: { trialing: 'Riceverai un codice di invito quando il tuo spazio di lavoro pagherà, dopo la prova.', free_run: 'Riceverai un codice di invito quando i mesi gratuiti saranno finiti e il tuo spazio di lavoro pagherà.', not_billing: 'Riceverai un codice di invito quando il tuo spazio di lavoro avrà un abbonamento attivo.' }, loading: 'Caricamento del tuo codice di invito …', error: 'Al momento non è stato possibile leggere il tuo codice di invito. Riprova più tardi.', bonus: { title: 'I tuoi bonus per gli inviti', collect: 'Riscatta', ready: 'pronto da riscattare', startsOn: 'a partire dalla tua fattura del {date}', startsNext: 'a partire dalla tua prossima fattura', waits: 'attende spazio su una prossima fattura', carries: 'La tua prossima fattura include {items}.', capped: 'con tetto', running: { promo: '{percent} % di codice promozionale', module: '{percent} % di codice modulo', referral: '{percent} % di bonus invito' }, collected: 'Riscattato: il bonus viene ora detratto dalle tue prossime fatture.', alreadyRunning: 'Questo bonus è già in corso.', collectFailed: 'Al momento non è stato possibile riscattare il bonus. Riprova.', hint: { ceiling: 'Non ancora: la tua prossima fattura include già {running}, e con questo bonus supererebbe il limite del {ceiling} %.', ceilingRunning: 'Non ancora: la tua prossima fattura include già {running}, il che non lascia spazio a questo bonus.', ceilingLimit: 'Non ancora: con questo bonus la tua prossima fattura supererebbe il limite del {ceiling} %.', ceilingPlain: 'Non ancora: gli sconti della tua prossima fattura non lasciano spazio a questo bonus.', roomNext: 'Un bonus in corso termina con la tua prossima fattura.', roomLater: 'Il primo bonus in corso termina tra {n} fatture.', notActive: 'Questo bonus attende finché il tuo spazio di lavoro non è di nuovo attivo.', deletion: 'Questo bonus attende finché per il tuo spazio di lavoro è aperta una richiesta di eliminazione.', unavailable: 'Al momento non si può verificare se questo bonus può essere riscattato. Riprova tra poco.' } }, history: { title: 'I tuoi inviti', empty: 'Nessuno ha ancora usato il tuo codice.', waiting: 'Usato il {date} — in attesa del primo mese pagato', bonusEarned: 'Ottenuto il {date}: {percent} % di sconto su 1 fattura | Ottenuto il {date}: {percent} % di sconto su {n} fatture', bonusCap: ', con tetto di {cap} per fattura', bonusOn: 'sulla tua fattura di {months} | sulle tue fatture di {months}', bonusToCome: '{n} in arrivo', bonusNone: 'non ancora su una fattura' } },
    errors: { setupFailed: 'Configurazione della carta non riuscita.', loadFailed: 'Impossibile caricare i dati di fatturazione.', ownerOnly: 'Solo il proprietario dello spazio di lavoro può gestire la fatturazione.', planChangeFailed: 'Impossibile cambiare il tuo piano. Riprova.', paymentStanding: 'Salda il pagamento in sospeso prima di effettuare l\'upgrade.', cardRequired: 'Aggiungi una carta valida prima di effettuare l\'upgrade.', addModuleFailed: 'Impossibile aggiungere il modulo. Riprova.', cancellationPending: 'Il tuo abbonamento sta per terminare. Scegli prima «Mantieni abbonamento», poi aggiungi il modulo.', removeFailed: 'Impossibile pianificare la rimozione. Riprova.' },
    retry: 'Riprova',
    common: { close: 'Chiudi' },
    card: {
      label: 'Carta', title: 'Metodo di pagamento',
      remove: 'Rimuovi carta', removed: 'Carta rimossa.',
      inUse: 'Questa carta è già stata fatturata e può essere solo sostituita, non rimossa.',
      removeConfirmTitle: 'Rimuovere la carta?', removeConfirmBody: 'Questo rimuove la carta registrata. Puoi aggiungerne una nuova in qualsiasi momento.',
      removeError: 'Impossibile rimuovere la carta.',
      handoff: 'Invia un link di pagamento a un\'altra persona', handoffTitle: 'Link di pagamento',
      handoffHint: '«Aggiungi/sostituisci carta»: inserisci tu stesso i dati della carta. «Invia un link di pagamento a un\'altra persona»: invia un link monouso a chi configura la carta, ad es. il tuo ufficio contabilità.',
      handoffBody: 'Condividi questo link monouso con chi configura la carta. Scade il {date}.',
      copy: 'Copia', copied: 'Copiato', handoffCopied: 'Link di pagamento copiato', handoffError: 'Impossibile creare un link di pagamento.',
    },
    recovery: {
      title: 'Pagamento in sospeso · {amount}',
      body: 'La tua banca deve confermare questo pagamento. Confermalo ora per mantenere l’accesso.',
      cta: 'Conferma pagamento',
      paid: 'Pagamento ricevuto: il tuo accesso è stato ripristinato.',
      failed: 'Il pagamento non è stato completato. Puoi riprovare in qualsiasi momento.',
      checking: 'Stiamo ancora verificando il pagamento…',
      startError: 'Non è stato possibile avviare il pagamento in questo momento. Riprova tra un attimo.',
    },
    plan: {
      title: 'Piano e moduli', subtitle: 'Gestisci il piano per ciascun modulo attivo.',
      currentPlan: 'Piano attuale', current: 'Attuale',
      perMonth: '{amount}/mese', perUserMonth: '{amount} per utente/mese', perApprenticeMonth: '{amount} per apprendista/mese', volumeHint: 'Sconto volume: i workspace più grandi pagano automaticamente meno per postazione.',
      perUpgradeMonth: '{amount} per estensione/mese',
      upgrade: 'Upgrade', downgrade: 'Downgrade', apply: 'Cambia piano',
      downgradeNote: 'I downgrade hanno effetto all\'inizio del tuo prossimo ciclo di fatturazione.',
      fixCardCta: 'Correggi metodo di pagamento',
      enterprise: { title: 'Ti serve di più?', body: 'Team più grandi e condizioni personalizzate si concordano con il nostro team.', cta: 'Contatta le vendite' },
      provisioning: 'Configurazione in corso — può richiedere un minuto.',
      provisioningFailed: 'Configurazione non riuscita — ce ne stiamo occupando.',
      removeModule: 'Rimuovi modulo', removeConfirmTitle: 'Rimuovere il modulo?',
      removeConfirmBody: '{module} verrà rimosso alla fine del tuo ciclo di fatturazione attuale. Fino ad allora puoi annullare l\'operazione.',
      removeScheduled: 'Rimozione di {module} pianificata.',
      addTitle: 'Aggiungi un modulo', addSubtitle: 'Estendi il tuo spazio di lavoro con un altro modulo.',
      addCta: 'Aggiungi modulo', addConfirmTitle: 'Aggiungere il modulo?',
      moduleLabel: 'Modulo', planLabel: 'Piano',
      // The booking table's column heads and its sum row's start date (#409 F12).
      booking: { price: 'Prezzo', seats: 'Postazioni', monthly: 'Al mese', from: 'dal {date}' },
      apprenticeSeats: 'Postazioni apprendista prenotate',
      apprenticeSeatsHint: 'Almeno 1 postazione apprendista per il modulo formazione.',
      apprenticeSeatsCeiling: 'Oltre {max} postazioni apprendista non esiste un piano self-service: lo definiamo direttamente con te:',
      apprenticeSeatAdjustment: 'Avevi prenotato {booked} postazioni apprendista prima che questo modulo venisse rimosso, quindi è stato riaggiunto con {booked} postazioni invece delle {requested} richieste. Puoi ridurle a partire dal prossimo addebito.',
      added: '{module} aggiunto.',
      addedPaymentRetrying: '{module} è stato aggiunto ed è pronto all\'uso. Non siamo riusciti a incassare il pagamento in questo momento — riproveremo automaticamente.',
      alreadyActive: '{module} è già incluso nel tuo piano.',
    },
    seats: {
      title: 'Postazioni prenotate',
      userSeats: 'Postazioni utente', apprenticeSeats: 'Postazioni apprendista',
      stepUp: 'Più postazioni', stepDown: 'Meno postazioni',
      bookMore: 'Prenota altre postazioni',
      confirmTitle: 'Prenotare altre postazioni?', confirmCta: 'Prenota postazioni',
      chargeNote: 'Prenotare altre postazioni addebita un importo proporzionale per il resto di questo ciclo di fatturazione.',
      confirmTitleDecrease: 'Ridurre le postazioni prenotate?',
      reduceCta: 'Riduci postazioni',
      decreaseNote: 'Oggi non viene addebitato né accreditato nulla: la prenotazione cambia il {date}.',
      decreaseNoteImmediate: 'Non viene addebitato né accreditato nulla: la prenotazione cambia subito.',
      decreaseScheduled: 'Riduzione delle postazioni pianificata per il {date}.',
      mixedDirection: 'Prenota altre postazioni e riducile in passaggi separati: le postazioni aggiunte si pagano oggi, quelle rimosse valgono dal prossimo ciclo di fatturazione.',
      belowUsage: 'Il tuo spazio di lavoro usa più postazioni di così. Mantienine almeno {count}.',
      usageCheckUnavailable: 'Non siamo riusciti a verificare quante postazioni sono occupate in questo momento. Riprova tra poco.',
      leaveFreelancer: 'Così esci dalla modalità freelance.',
      returnFreelancer: 'Così torni alla modalità freelance: una persona, una postazione.',
      booked: 'Le tue postazioni prenotate sono state aggiornate.',
      bookedPaymentRetrying: 'Le tue postazioni sono prenotate e pronte all\'uso. Non siamo riusciti a incassare il pagamento in questo momento — riproveremo automaticamente.',
      bookFailed: 'Non è stato possibile prenotare le postazioni. Riprova.',
    },
    seatPanel: {
      inUse: '{used} di {booked} in uso',
      bookedOnly: '{booked} prenotate',
      useUnknown: 'Non siamo riusciti a leggere quante sono in uso in questo momento.',
      manage: 'Gestisci postazioni',
      pendingUsers: 'Le postazioni utente passano a {target} il {date}: fino ad allora ne hai prenotate {current}.',
      pendingApprentices: 'Le postazioni apprendista passano a {target} il {date}: fino ad allora ne hai prenotate {current}.',
      reflooredUsers: 'La tua riduzione a {requested} postazioni utente è stata applicata a {booked}: nello spazio di lavoro ci sono {used} persone e ognuna occupa una postazione. Rimuovi quelle che non ti servono più, poi riduci di nuovo.',
      reflooredApprentices: 'La tua riduzione a {requested} postazioni apprendista è stata applicata a {booked}: ci sono {used} apprendistati in corso. Concludi quelli che non ti servono più, poi riduci di nuovo.',
      // A demo workspace's apprentices hold no booked seat (issue 364 F4/F30):
      // the creation gate ignores the booking while the demo runs, so the count
      // excludes them and this row says so.
      demoNotCounted: 'Gli apprendisti dei dati dimostrativi non occupano postazioni prenotate: non sono conteggiati qui e spariscono quando confermi la demo.',
    },
    // The seat price calculator (issue 364 F30). Every FIGURE it shows arrives
    // from the API; these are only the words around them.
    calc: {
      title: 'Quanto costa questa prenotazione',
      includes: 'Che cosa include la tua prenotazione e quanto costa al mese.',
      userSeatsCount: '{count} postazioni utente',
      apprenticeSeatsCount: '{count} postazioni apprendista',
      aiQuotaUpgradesCount: '{count} × estensione',
      subtotal: 'Subtotale',
      volumeDiscount: 'Sconto quantità',
      monthlyTotal: 'Totale mensile',
      currentTotal: 'Oggi paghi {amount} al mese.',
      newMonthlyTotal: 'Dalla prossima fattura: {amount} al mese.',
      netNote: 'Prezzi IVA esclusa. Prenotare altre postazioni comporta anche un importo una tantum proporzionale per il resto del ciclo di fatturazione in corso.',
    },
    // The AI quota card (#665). Every figure it shows arrives from the API.
    aiQuota: {
      title: 'Quota IA',
      usageLink: 'Dove viene usata',
      ownKey: 'Questo spazio di lavoro usa lumi con una propria chiave di un fornitore IA, quindi non ha una quota IA: il tuo fornitore ti fattura direttamente ogni token.',
      suspended: 'La quota IA è sospesa finché lo spazio di lavoro è sospeso.',
      unlimited: 'Per questo spazio di lavoro non vale alcuna quota IA: lumi ha rimosso il limite.',
      intro: 'lumi, le funzioni IA di tutti i moduli e gli agenti IA esterni collegati dai membri condividono un’unica quota: fino a {limit} token per ciclo di fatturazione. Si rinnova all’inizio di ogni ciclo di fatturazione; i token non usati non si accumulano.',
      included: 'Inclusa',
      includedDerived: 'con le tue postazioni prenotate',
      includedOverride: 'stabilita da lumi per questo spazio di lavoro',
      tokensValue: '{tokens} token per ciclo',
      upgrades: 'Estensioni della quota',
      upgradesNone: 'Nessuna prenotata',
      upgradesValue: 'Prenotate: {count} · +{tokens} token',
      used: 'Usata in questo ciclo',
      usedValue: '{used} di {limit} token',
      usedNoLimit: '{used} token finora',
      resetsOn: 'Si rinnova il {date}',
      stepPrice: 'Un’estensione aggiunge {tokens} token per ciclo di fatturazione a {amount} al mese.',
      stepUp: 'Un’estensione in più',
      stepDown: 'Un’estensione in meno',
      removeCta: 'Rimuovi alla prossima data di fatturazione',
      confirmTitle: 'Aggiungere un’estensione della quota IA?',
      confirmTitleDecrease: 'Rimuovere un’estensione della quota IA?',
      confirmCta: 'Prenota estensione',
      trialWarning: 'Questo costa denaro reale, anche durante la tua prova: oggi la tua carta viene addebitata in proporzione per il resto della prova, per un mese al massimo, e poi ogni mese.',
      cardRequired: 'Per un’estensione della quota IA ti serve una carta attiva, anche durante la prova. Aggiungi prima la tua carta: appena è confermata puoi prenotare l’estensione.',
      promoExcluded: 'Il tuo codice non vale per la quota IA: un’estensione non viene mai scontata e viene addebitata al prezzo di listino.',
      chargeNote: 'Un’estensione addebita un importo proporzionale per il resto di questo ciclo di fatturazione e vale subito.',
      decreaseNote: 'Oggi non viene addebitato né accreditato nulla. Mantieni l’estensione fino al {date}; da allora vale la quota ridotta.',
      decreaseNoteGeneric: 'Oggi non viene addebitato né accreditato nulla: l’estensione termina alla prossima data di fatturazione.',
      newQuota: 'Dopo: fino a {limit} token per ciclo di fatturazione.',
      changeDelta: '{tokens} token · {amount} / mese',
      addCtaPrice: 'Aggiungi estensione della quota · {amount} / mese',
      booked: 'Le tue estensioni della quota IA sono state aggiornate.',
      bookedPaymentRetrying: 'La tua estensione della quota IA è prenotata e vale subito. Non siamo riusciti a incassare il pagamento in questo momento — riproveremo automaticamente.',
      decreaseScheduled: 'L’estensione della quota IA termina il {date}.',
      pending: 'Le estensioni della quota passano a {target} il {date}: fino ad allora ne hai prenotate {current}.',
      bookFailed: 'Non è stato possibile modificare le estensioni della quota IA. Riprova.',
    },
    scheduled: {
      resizeTo: 'Passa a {plan}', remove: 'Rimuovi modulo',
      effective: 'con effetto dal {date}', revert: 'Annulla', reverted: 'Modifica pianificata annullata.',
    },
    proration: {
      title: 'Conferma il cambio di piano', stepFrom: 'Attuale', stepTo: 'Nuovo',
      chargeNote: 'Effettuare l\'upgrade ora addebita un importo proporzionale per il resto di questo ciclo di fatturazione.',
      freeNote: 'Questa modifica si applica immediatamente senza costi aggiuntivi durante la tua prova.',
      confirm: 'Conferma ed effettua l\'upgrade', cancel: 'Annulla',
      charged: 'Addebitati {amount}.', appliedImmediate: 'Il tuo nuovo piano è attivo.',
      appliedScheduled: 'Pianificato — con effetto dal {date}.',
      calculating: 'Stiamo calcolando l\'importo esatto…',
      chargeExact: 'Oggi ti verranno addebitati {amount}.',
      noChargeToday: 'Nessun addebito oggi.',
    },
    profile: {
      title: 'Dati di fatturazione', subtitle: 'Completa i tuoi dati di fatturazione per attivare il pagamento.',
      legalName: 'Ragione sociale', addressLine1: 'Indirizzo', addressLine2: 'Indirizzo (riga 2)',
      postalCode: 'CAP', city: 'Città', vatId: 'Partita IVA',
      vatOptional: 'Facoltativa — necessaria per l\'inversione contabile all\'interno dell\'UE.',
      save: 'Salva dati', edit: 'Modifica dati di fatturazione', error: 'Impossibile salvare i tuoi dati di fatturazione.',
      saved: 'Dati di fatturazione salvati.',
      vatPending: 'Non siamo riusciti a verificare la tua partita IVA in questo momento. Riprova a breve.',
      vatInvalid: 'Non è stato possibile validare questa partita IVA. Controllala.',
      vatRequired: 'Per il tuo paese è necessaria una partita IVA valida prima di aggiungere una carta.',
      completeFirst: 'Completa i tuoi dati di fatturazione prima di aggiungere una carta.',
    },
    cancel: {
      title: 'Annulla abbonamento',
      body: 'Annulla il tuo abbonamento. Il tuo spazio di lavoro resta attivo fino alla fine del ciclo di fatturazione in corso.',
      reason: 'Motivo (facoltativo)', confirm: 'Annulla abbonamento', confirmTitle: 'Annullare l\'abbonamento?',
      confirmBody: 'Il tuo abbonamento termina il {date}. Fino ad allora tutto continua a funzionare.',
      note: 'Fino ad allora tutto continua a funzionare, compresa l’esportazione dell’intero spazio di lavoro. Poi lo spazio di lavoro viene chiuso; i suoi dati restano per un certo tempo e i proprietari vengono avvisati prima che venga eliminato qualcosa. Se deve sparire prima, usa «{deletion}».',
      pending: 'Annullamento pianificato — il tuo abbonamento termina il {date}.', pendingNoDate: 'Annullamento pianificato.',
      revert: 'Mantieni abbonamento', error: 'Impossibile annullare il tuo abbonamento.',
      done: 'Annullamento pianificato. Il tuo spazio di lavoro resta attivo fino alla fine del ciclo di fatturazione corrente.', revertDone: 'Annullamento revocato. Il tuo abbonamento prosegue normalmente.',
    },
    deletion: {
      title: 'Elimina spazio di lavoro (GDPR)',
      body: 'Richiedi l\'eliminazione permanente di questo spazio di lavoro e di tutti i suoi dati. Dopo un breve periodo di grazia, questa operazione non può essere annullata.',
      request: 'Richiedi eliminazione', reason: 'Motivo (facoltativo)',
      confirmTitle: 'Richiedere l\'eliminazione dello spazio di lavoro?',
      confirmBody: 'Tutti i dati saranno cancellati in modo permanente dopo un breve periodo di grazia. Questa operazione non può essere annullata.',
      pending: 'Eliminazione richiesta — i dati vengono cancellati dopo il {date}.', pendingNoDate: 'Eliminazione richiesta e in attesa di revisione.',
      cancel: 'Annulla richiesta di eliminazione', error: 'Impossibile inviare la tua richiesta di eliminazione.',
      requested: 'Eliminazione richiesta. Cancelleremo il tuo spazio di lavoro dopo il periodo di grazia.', canceled: 'Richiesta di eliminazione ritirata. Il tuo spazio di lavoro viene mantenuto.',
      confirmType: 'Digita il nome dello spazio di lavoro ({name}) per confermare',
      cancelConfirmTitle: 'Ritirare la richiesta di eliminazione?',
      cancelConfirmBody: 'Il tuo spazio di lavoro e tutti i suoi dati vengono mantenuti. Puoi richiedere di nuovo l\'eliminazione in qualsiasi momento.',
    },
    moduleNames: { core: 'lumi-HR Core', ats: 'Recruiting', time_tracking: 'Tempo', apprenticeship: 'Ausbildung' },
    planNames: {
      ats: { seat: 'Per utente', enterprise: 'Enterprise', unknown: '—' },
      time: { seat: 'Per utente', enterprise: 'Enterprise', unknown: '—' },
      apprenticeship: { seat: 'Per apprendista', enterprise: 'Enterprise', unknown: '—' },
      // People Pro is retired (#596), but issued invoices keep their `peoplePro.seat`
      // line (GoBD) and render through this entry — keep it while any exists.
      peoplePro: { seat: 'Per utente', enterprise: 'Enterprise', unknown: '—' },
      // The AI quota upgrade line (#665): its displayKey is `ai_quota.upgrade`.
      ai_quota: { upgrade: 'Estensione della quota IA (+1.000.000 token per ciclo di fatturazione)' },
    },
    onboard: {
      // Three honest branches, never a CTA without a control (#364 F18/F23).
      // `exempt` is checked FIRST, ahead of demo: an operator-granted exemption
      // is a deliberate state, not a broken signup and not a demo limitation.
      exempt: { title: 'Questo spazio di lavoro è esente da fatturazione', body: 'lumi ha stabilito che questo spazio di lavoro non viene fatturato, quindi non ha un account di fatturazione e non ti viene né ti verrà addebitato nulla. Solo lumi può modificarlo: qui non c’è nulla da configurare.' },
      demo: { title: 'La fatturazione non è disponibile in modalità demo', body: 'Questo spazio di lavoro usa dati dimostrativi, quindi non c’è ancora nulla da fatturare. La fatturazione potrà essere configurata quando convertirai la demo in una configurazione reale: il banner demo in cima alla pagina avvia questa operazione.' },
      // The stranded signup's real recovery is the buyer redoing the SAME checkout,
      // which resumes THIS workspace (issue 364 F25) — support is the fallback, and
      // for anyone who is not the buyer it is the only route they have.
      stranded: { title: 'La configurazione della fatturazione non è stata completata', buyerBody: 'La tua registrazione non è stata completata, quindi questo spazio di lavoro non ha ancora un account di fatturazione e non viene addebitato nulla. Puoi completarla tu: torna al pagamento e acquista di nuovo gli stessi moduli — così questo spazio di lavoro riprende da dove si era fermato invece di crearne un secondo. Se ancora non va a buon fine, scrivici e la completeremo insieme a te.', otherBody: 'La tua registrazione non è stata completata, quindi questo spazio di lavoro non ha ancora un account di fatturazione e non viene addebitato nulla. Può completarla solo la persona che ha registrato questo spazio di lavoro, tornando al pagamento e acquistando di nuovo gli stessi moduli. Chiediglielo, oppure scrivici e la completeremo insieme a te.', checkoutCta: 'Torna al pagamento', cta: 'Contatta l’assistenza' },
    },
    // The four documents this workspace's billing relationship is
    // governed by, on the landing host (#576 M2) — not a "version you
    // accepted" claim, just the current published text.
    contractDocuments: {
      title: 'Documenti contrattuali',
      terms: 'Termini e condizioni',
      avv: 'Accordo sul trattamento dei dati (AVV)',
      tom: 'Misure tecniche e organizzative (TOM)',
      subprocessors: 'Subresponsabili del trattamento',
    },
  },
  login: {
    ssoApple: 'Accedi con Apple',
    passkeySignIn: 'Accedi con una passkey',
    passkeySigningIn: 'Accesso in corso…',
    passkeyFailed: 'L’accesso con passkey non è riuscito. Riprova o usa la password.',
    title: 'lumi-HR Suite',
    subtitle: 'Accedi per continuare',
    email: 'E-mail',
    emailPlaceholder: "nome{'@'}azienda.it",
    password: 'Password',
    passwordPlaceholder: 'La tua password',
    signIn: 'Accedi',
    signingIn: 'Accesso in corso…',
    failed: 'Accesso fallito',
    forgotPassword: 'Password dimenticata?',
    lostPhone: 'Hai perso il telefono?',
    orContinueWith: 'oppure continua con',
    ssoGoogle: 'Accedi con Google',
    ssoMicrosoft: 'Accedi con Microsoft',
    ssoEnterprise: 'Accedi con l’SSO aziendale',
    ssoOnly: 'L’accesso a questo spazio di lavoro avviene tramite l’SSO della tua azienda.',
    adminLogin: 'Accesso amministratore',
    ssoError: 'Accesso SSO fallito. Riprova.',
    ssoSeatLimit: 'Questo workspace non ha postazioni utente libere, quindi non abbiamo potuto creare un account per te. Chiedi al proprietario del workspace o a un Billing Manager di prenotare un’altra postazione: riprovare non servirà finché non lo fa.',
    ssoLinkRequired: 'Non è stato possibile collegare automaticamente questo accesso aziendale al tuo account lumi. Accedi in un altro modo, poi collega l’accesso aziendale in Account e sicurezza.',
    ssoEmployeeNoticeIncomplete: 'Questo workspace non è ancora pronto: le informative per i dipendenti hanno ancora campi da completare. Chiedi al proprietario del workspace, a un\'amministrazione suite o al responsabile della protezione dei dati di completarli nella sezione Note legali — riprovare non servirà finché non lo fa.',
    ssoLegalReadinessUnavailable: 'Al momento non siamo riusciti a verificare se questo workspace è pronto. Riprova tra qualche minuto.',
    ssoOperatorPasswordOnly: 'Gli account di amministratore di sistema accedono con password e app di autenticazione, non con questo provider.',
    mfaTitle: 'Inserisci il codice di autenticazione',
    mfaIntro: 'Questo è un account di amministratore di sistema. Inserisci il codice a 6 cifre della tua app di autenticazione o uno dei tuoi codici di recupero.',
    mfaCode: 'Codice',
    mfaSubmit: 'Accedi',
    mfaBack: 'Indietro',
    mfaInvalid: 'Il codice non è corretto.',
    mfaReused: 'Questo codice è già stato usato. Attendi il prossimo nella tua app.',
    mfaExpired: 'Questo accesso è scaduto. Accedi di nuovo con la tua password.',
    mfaEnrolOnConsole: 'Questo account di amministratore di sistema non ha ancora un’app di autenticazione. Configurala prima accedendo alla console lumi.',
    tenantLogoAlt: 'Logo dello spazio di lavoro',
    poweredBy: 'Con tecnologia',
  },
  loginBranding: {
    nav: 'Pagina di accesso',
    title: 'Pagina di accesso',
    intro: 'Dai alla pagina di accesso di questo spazio di lavoro un logo, un colore e un’immagine di sfondo tuoi. La vede chiunque acceda da qui.',
    retry: 'Riprova',
    loadFailed: 'Non è stato possibile caricare le impostazioni attuali.',
    form: {
      title: 'Aspetto',
      logo: 'Logo',
      logoHint: 'PNG, JPEG, WebP o GIF, fino a 2 MB. Lascia vuoto per mantenere il logo lumi.',
      image: 'Immagine di sfondo',
      imageHint: 'Mostrata dietro la scheda di accesso. PNG, JPEG, WebP o GIF, fino a 8 MB.',
      upload: 'Carica',
      replace: 'Sostituisci',
      remove: 'Rimuovi',
      empty: 'Nessuna immagine',
      uploaded: 'Immagine caricata.',
      removed: 'Immagine rimossa.',
      tooLarge: 'Questo file è troppo grande.',
      wrongType: 'Sono accettate solo immagini PNG, JPEG, WebP e GIF.',
      uploadFailed: 'Non è stato possibile caricare l’immagine. Riprova.',
      removeFailed: 'Non è stato possibile rimuovere l’immagine. Riprova.',
      removeConfirm: 'L’immagine viene tolta dalla pagina di accesso ed eliminata. L’operazione non può essere annullata.',
      primaryColor: 'Colore principale',
      colorPlaceholder: 'es. 1a2b3c',
      colorInvalid: 'Inserisci un colore esadecimale come 1a2b3c.',
      clear: 'Cancella',
      save: 'Salva',
      saved: 'Pagina di accesso aggiornata.',
      discard: 'Annulla le modifiche',
      liveNote: 'Le modifiche salvate si vedono alla prossima apertura della pagina di accesso.',
    },
    preview: {
      title: 'Anteprima',
      hint: 'Ecco come appare la pagina di accesso con i valori qui sopra.',
      logoAlt: 'Anteprima del logo',
    },
  },
  authFlow: {
    forgot: {
      title: 'Reimposta la tua password',
      subtitle: 'Ti invieremo un link per reimpostarla.',
      email: 'E-mail',
      submit: 'Invia link',
      done: 'Se esiste un account con quell’indirizzo e-mail, abbiamo inviato un link per la reimpostazione.',
      backToLogin: 'Torna all’accesso',
    },
    reset: {
      title: 'Imposta una nuova password',
      password: 'Nuova password',
      confirm: 'Conferma password',
      submit: 'Salva password',
      success: 'La tua password è stata modificata. Ora puoi accedere.',
      goToLogin: 'Vai all’accesso',
      invalid: 'Questo link non è valido o è scaduto.',
      mismatch: 'Le password non corrispondono.',
      tooShort: 'La password deve contenere almeno 8 caratteri.',
      missingToken: 'Nessun token valido trovato.',
    },
    invite: {
      title: 'Configura il tuo account',
      subtitle: 'Scegli una password per attivare il tuo account.',
      forTenant: 'Invito a {tenant}',
      password: 'Password',
      confirm: 'Conferma password',
      submit: 'Attiva account',
      submitting: 'Attivazione…',
      invalid: 'Questo invito non è valido o è scaduto.',
      mismatch: 'Le password non corrispondono.',
      tooShort: 'La password deve contenere almeno 8 caratteri.',
      passkey: {
        title: 'Configura il tuo accesso',
        intro: 'Accedi a lumi con una passkey: impronta, volto o PIN del dispositivo. Nessuna password da ricordare.',
        sentTo: 'Inviato a {phone}',
        create: 'Crea una passkey',
        creating: 'In attesa del tuo dispositivo…',
        instead: 'Usa invece una passkey',
        or: 'oppure',
        unsupported: 'Questo browser non può creare una passkey. Apri il link sul tuo telefono o in un browser aggiornato.',
        unavailable: 'Le passkey non sono disponibili qui per questo spazio di lavoro. Contatta il tuo amministratore.',
        expired: 'Ci è voluto troppo tempo. Riprova.',
        alreadyRegistered: 'Questo dispositivo ha già una passkey per lumi.',
        failed: 'Non è stato possibile creare la passkey. Riprova.',
      },
    },
    recover: {
      title: 'Hai perso il telefono?',
      subtitle: 'Inserisci il tuo numero di cellulare e ti invieremo via SMS un link per configurare una nuova passkey.',
      phone: 'Numero di cellulare',
      phoneHint: 'Con il prefisso internazionale, ad es. +39 312 345 6789',
      submit: 'Invia link',
      done: 'Se questo numero appartiene a un account qui, gli abbiamo inviato un link. È valido per 15 minuti.',
      enrolTitle: 'Configura una nuova passkey',
      enrolSubtitle: 'Crea una passkey su questo dispositivo. Tutte le altre sessioni del tuo account verranno chiuse.',
      create: 'Crea una nuova passkey',
      invalid: 'Questo link non è valido o è scaduto. Richiedine uno nuovo.',
    },
    verify: {
      verifying: 'Conferma della tua e-mail…',
      success: 'Il tuo indirizzo e-mail è stato confermato.',
      invalid: 'Questo link di conferma non è valido o è scaduto.',
      backToLogin: 'Vai all’accesso',
    },
  },
  account: {
    // AI agent connections on the account page (ADR 0103 rule 13).
    agentConnections: {
      title: 'Collegamenti di agenti IA',
      hint: 'I client IA a cui hai permesso di agire per tuo conto in un workspace. Ognuno lavora esattamente con i tuoi permessi, e ciò che legge va al fornitore di quel client.',
      none: 'Nessun agente IA collegato.',
      inWorkspace: 'nel workspace {workspace}',
      scope: {
        read: 'lettura',
        act: 'azioni con conferma',
        ask: 'domande a lumi',
      },
      lastUsed: 'Ultimo utilizzo il {when}',
      connectedOn: 'Collegato il {when}, non ancora usato',
      standing: {
        label: 'Esegui le azioni sui miei dati senza chiedere',
        hint: 'Non vale mai per i dati di altre persone né per decisioni sfavorevoli.',
        notOffered: 'Per questo collegamento non è possibile un consenso permanente.',
        failed: 'Non è stato possibile modificare l’impostazione. Riprova.',
      },
      rolePins: {
        notHeld: 'Non hai più quel ruolo in questo modulo.',
        failed: 'Non è stato possibile cambiare il ruolo. Riprova.',
      },
      disconnect: 'Scollega',
      disconnectConfirm: '«{client}» perde subito l’accesso a {workspace}. Per usarlo di nuovo, ricollegalo dal client.',
      disconnected: '{client} scollegato.',
      disconnectFailed: 'Non è stato possibile terminare il collegamento. Riprova.',
    },
    passkeys: {
      removeConfirm: 'Questa passkey verrà rimossa. Il dispositivo che la usa non potrà più accedere con essa.',
      title: 'Passkey',
      hint: 'Una passkey ti fa accedere con il tuo dispositivo: impronta, volto o PIN. Niente da ricordare e niente da sottrarre con il phishing.',
      none: 'Nessuna passkey.',
      add: 'Aggiungi una passkey',
      remove: 'Rimuovi',
      unnamed: 'Passkey',
      lastUsed: 'Ultimo utilizzo il {when}',
      neverUsed: 'Mai usata',
      added: 'Passkey aggiunta.',
      removed: 'Passkey rimossa.',
      addFailed: 'Non è stato possibile aggiungere la passkey. Riprova.',
      removeFailed: 'Non è stato possibile rimuovere la passkey. Riprova.',
      alreadyRegistered: 'Questo dispositivo ha già una passkey per lumi.',
      lastMethod: 'Non puoi rimuovere il tuo unico metodo di accesso. Imposta prima una password o aggiungi un’altra passkey.',
      lostDevice: 'Hai perso un telefono o un altro dispositivo? Rimuovi la sua passkey da questo elenco: è questo che gli toglie l’accesso al tuo account.',
    },
    currentPassword: 'Password attuale',
    phone: {
      title: 'Numero di accesso',
      hint: 'Il tuo account accede con una passkey. A questo numero arrivano i link di invito e di recupero.',
    },
    email: {
      title: 'Indirizzo di accesso',
      hint: 'L\'indirizzo con cui accedi. Cambiarlo cambia anche l\'indirizzo che i tuoi spazi di lavoro mostrano per te.',
      newLabel: 'Nuovo indirizzo',
      submit: 'Richiedi la modifica',
      pending: 'In attesa di conferma su {email}. Segui il link che abbiamo inviato lì.',
      cancel: 'Annulla questa modifica',
      cancelled: 'La modifica di indirizzo in sospeso è stata annullata.',
      sent: 'Controlla la nuova casella. Non cambia nulla finché non segui il link.',
      refused: 'Quell\'indirizzo non può essere usato per questo account. Uno dei tuoi spazi di lavoro consente solo indirizzi sui propri domini.',
      failed: 'Non è stato possibile richiedere la modifica. Riprova.',
      ssoManaged: 'Il tuo indirizzo di accesso è gestito dal tuo provider di identità.',
    },
    password: {
      title: 'Password',
      hint: 'Cambiare la password ti disconnette ovunque altrove.',
      newLabel: 'Nuova password',
      confirmLabel: 'Ripeti la nuova password',
      submit: 'Cambia password',
      changed: 'La tua password è stata cambiata. Gli altri dispositivi sono stati disconnessi.',
      wrongCurrent: 'La password attuale non è corretta.',
      failed: 'Non è stato possibile cambiare la password. Riprova.',
      tooShort: 'La nuova password deve avere almeno 8 caratteri.',
      mismatch: 'Le due nuove password non coincidono.',
      ssoOnly: 'Questo account accede tramite il tuo provider di identità, quindi non ha una password. Puoi aggiungerne una come riserva: ti invieremo un link.',
      sendLink: 'Inviami un link per impostare una password',
      linkSent: 'Se è possibile impostare una password per questo account, il link è in arrivo.',
      linkFailed: 'Non è stato possibile inviare la richiesta. Riprova.',
    },
    confirmEmail: {
      title: 'Conferma il tuo nuovo indirizzo',
      working: 'Conferma in corso…',
      success: 'Il tuo indirizzo di accesso è stato cambiato. Accedi di nuovo con il nuovo indirizzo.',
      goToLogin: 'Vai all\'accesso',
      backToAccount: 'Torna a Account e sicurezza',
      missingToken: 'Questo link è incompleto. Aprilo direttamente dall\'e-mail.',
      invalid: 'Questo link di conferma non è valido o è scaduto.',
      unavailable: 'Questa modifica non può più essere applicata. Richiedila di nuovo.',
    },
    // The undo half (#420): the notice mailed to the address being LEFT
    // BEHIND carries this link, and it only ever restores the status quo.
    cancelEmailChange: {
      title: 'Annulla la modifica dell\'indirizzo',
      working: 'Annullamento…',
      success: 'La modifica è stata annullata. Continui ad accedere con il tuo indirizzo attuale.',
      goToLogin: 'Vai all\'accesso',
      missingToken: 'Questo link è incompleto. Aprilo direttamente dall\'e-mail.',
      invalid: 'Questo link non è valido o è scaduto: non c’è più alcuna modifica da annullare.',
    },
    title: 'Account e sicurezza',
    identities: 'Metodi di accesso collegati',
    noIdentities: 'Nessun metodo di accesso esterno collegato.',
    unlink: 'Rimuovi',
    // #882: removing a linked sign-in method asks first, as removing a passkey does.
    unlinkConfirm: 'Questo metodo di accesso verrà rimosso. Non potrai più accedere al tuo account con esso.',
    linkGoogle: 'Collega Google',
    linkMicrosoft: 'Collega Microsoft',
    linkApple: 'Collega Apple',
    lastMethod: 'Non puoi rimuovere il tuo unico metodo di accesso. Imposta prima una password.',
    linked: 'Metodo di accesso collegato.',
    unlinked: 'Metodo di accesso rimosso.',
    linkFailed: 'Collegamento fallito.',
  },
  workspace: {
    title: 'Area di lavoro',
    subtitle: 'Scegli un tenant e un modulo',
    brandName: 'lumi-HR Workspace',
    themeDark: 'Passa alla modalità scura',
    themeLight: 'Passa alla modalità chiara',
    welcomeTitle: 'Benvenuto nell’area di lavoro',
    welcomeSubtitle:
      'Seleziona il tenant e un modulo applicativo per iniziare.',
    availableModules: 'Moduli disponibili',
    comingSoonSection: 'Prossimamente in lumi-HR',
    adminMode: 'Modalità amministratore',
    aiUsage: {
      title: 'Utilizzo IA',
      pageIntro: 'Se lumi è disponibile in questo spazio di lavoro e quanto ha consumato l’IA questo mese.',
      loading: 'Caricamento utilizzo…',
      remaining: '{n} rimanenti',
      periodLabel: 'Ciclo di fatturazione',
      historyTitle: 'Cicli di fatturazione',
      usedThisPeriod: 'Usata in questo ciclo di fatturazione',
      split: '{included} inclusi · +{upgrades} dalle estensioni della quota',
      resetsOn: 'Si rinnova il {date}',
      periodFrom: 'Ciclo di fatturazione dal {date}',
      nearLimit: 'La quota IA di questo ciclo di fatturazione è quasi esaurita. Un’estensione della quota in Fatturazione la aumenta subito.',
      unlimited: 'Per questo spazio di lavoro non vale alcuna quota IA.',
      ownKey: 'Questo spazio di lavoro usa lumi con una propria chiave di un fornitore IA, quindi non ha una quota IA.',
      noUsageYet: 'Ancora nessun utilizzo dell’IA in questo ciclo di fatturazione.',
      upgradeLink: 'Aggiungi un’estensione della quota in Fatturazione',
      modules: {
        ats: 'Recruiting',
        time: 'Tempo',
        time_tracking: 'Tempo',
        apprentice: 'Ausbildung',
        apprenticeship: 'Ausbildung',
        assistant: 'Assistente lumi',
        mcp: 'Agenti esterni',
      },
    },
    active: 'Attivo',
    systemAdmin: 'Amministratore di sistema',
    user: 'Utente',
    admin: 'Amministrazione',
    comingSoon: 'Prossimamente',
    noTenants: 'Nessun tenant disponibile',
    createViaCheckout: 'Crea uno spazio di lavoro dalla pagina di pagamento',
    loadFailed: 'Impossibile caricare i tenant',
    planKlein: 'Piccolo',
    planMedium: 'Medio',
    planEnterprise: 'Enterprise',
    retry: 'Riprova',
    logout: 'Esci',
    noAccess: 'Nessun accesso',
  },
  support: {
    title: 'Richieste di supporto',
    myTickets: 'Le mie richieste',
    myTicketsTitle: 'Le mie richieste di supporto',
    inbox: 'Posta in arrivo',
    inboxTitle: 'Posta in arrivo assistenza',
    inboxSubtitle: 'Ticket dei tenant che gestisci',
    ticket: 'Ticket',
    newTicket: 'Nuova richiesta di supporto',
    newTicketTitle: 'Nuova richiesta di supporto',
    newTicketIntro: 'Descrivi il tuo problema e ti ricontatteremo.',
    sent: 'La tua richiesta è stata inviata.',
    goToMyRequests: 'Vai alle mie richieste di supporto',
    subject: 'Oggetto',
    subjectPlaceholder: 'Breve riepilogo',
    message: 'Messaggio',
    messagePlaceholder: 'Descrivi cosa è successo…',
    consentLabel: 'Accetto che i miei dati vengano trattati per gestire questa richiesta',
    send: 'Invia',
    reply: 'Rispondi',
    markComplete: 'Segna come completato',
    reopen: 'Riapri',
    replyPlaceholder: 'Scrivi una risposta…',
    escalate: 'Inoltra',
    escalated: 'Inoltrato',
    deescalate: 'Annulla inoltro',
    deescalateBlocked: 'Su questo ticket è ancora aperto un accesso del supporto. Revocalo prima, poi annulla l’inoltro.',
    close: 'Chiudi',
    statusLabel: 'Stato',
    module: 'Modulo',
    tenant: 'Tenant',
    requester: 'Richiedente',
    updated: 'Aggiornato',
    backToTickets: 'Torna alle mie richieste',
    status: {
      open: 'Aperto',
      in_progress: 'In corso',
      answer: 'Risposto',
      closed: 'Chiuso',
    },
    author: {
      user: 'Tu',
      support: 'Assistenza',
      systemAdmin: 'Amministratore di sistema',
    },
    empty: {
      myTitle: 'Ancora nessun ticket',
      myBody: 'Quando crei un ticket di assistenza, comparirà qui.',
      inboxTitle: 'Niente da gestire',
      inboxBody: 'Al momento non hai ticket di assistenza nei tuoi tenant.',
      notFoundTitle: 'Ticket non disponibile',
      notFoundBody: 'Impossibile caricare questo ticket. Potrebbe essere stato rimosso o non hai accesso.',
    },
  },
  notifications: {
    nav: 'Notifiche',
    title: 'Notifiche',
    subtitle: 'Cose che richiedono la tua attenzione.',
    settings: 'Impostazioni',
    backToWorkspace: 'Torna allo spazio di lavoro',
    area: 'Area',
    areaAll: 'Tutte le aree',
    status: 'Stato',
    statusAll: 'Tutte',
    statusUnread: 'Non lette',
    statusRead: 'Lette',
    perPage: 'Per pagina',
    markRead: 'Segna come letta',
    markUnread: 'Segna come non letta',
    markAllRead: 'Segna tutte come lette',
    loading: 'Caricamento…',
    empty: 'Sei aggiornato.',
    pageInfo: '{from}–{to} di {total}',
    prev: 'Precedente',
    next: 'Successivo',
    retentionHint: 'Le notifiche vengono conservate per 6 mesi.',
    settingsTitle: 'Configura le notifiche per area',
    settingsSubtitle: 'Scegli come vuoi essere notificato per ogni area.',
    // #445 M4 packet 2: the settings screen must say plainly what it cannot
    // switch off, and what a switched-off Area still lets through.
    mustReachIntro: 'Alcune notifiche su sicurezza, denaro, contratti, il tuo spazio di lavoro e scadenze legali raggiungono sempre le persone interessate — appaiono anche nella campanella.',
    // A phone-only account (issue 698): no address, so the mail half never goes out.
    noMailAddress: 'Il tuo account non ha un indirizzo e-mail, quindi le notifiche ti raggiungono nell’app (e come notifica push dove l’hai consentita). «{mailMode}» funziona quindi come «{inAppMode}»: nulla viene inviato via e-mail.',
    mustReachStillReaches: 'Anche disattivandolo, continuerai a ricevere {list} quando ti riguardano.',
    mandatoryReason: {
      billing: 'Non può essere disattivato: il denaro dovuto deve raggiungere la persona responsabile.',
      legal: 'Non può essere disattivato: le modifiche contrattuali devono raggiungerti, come promettono i nostri termini.',
    },
    mustReachFamily: {
      identity: 'notifiche di sicurezza',
      money: 'notifiche di fatturazione',
      legal: 'notifiche contrattuali',
      workspace: 'notifiche sullo stato dello spazio di lavoro',
      privacy: 'promemoria sulle scadenze relative alla privacy',
      participation: 'richieste alla rappresentanza dei lavoratori',
    },
    backToList: 'Torna alle notifiche',
    modeOff: 'Per niente',
    modeInApp: 'Solo nell’app',
    modeMailInApp: 'E-mail e nell’app',
    saved: 'Salvato.',
    saveError: 'Salvataggio non riuscito. L’impostazione è stata ripristinata.',
    openTarget: 'Apri l\'elemento collegato',
    opening: 'Apertura…',
    openFailed: 'Non è stato possibile aprire questa notifica.',
    areas: {
      system: 'Sistema',
      timecard: 'Tempo',
      ats: 'Recruiting',
      apprentice: 'Ausbildung',
      people: 'Personale',
      support: 'Supporto',
      postings: 'Annunci di lavoro',
      // Subscription, invoices, payment problems. A MANDATORY Area — the
      // row renders without a mode selector (review finding 3).
      billing: 'Fatturazione',
      // #373 M5: the contract-rollout notices (AGB, AVV, subprocessors). A
      // MANDATORY Area — the row renders without a mode selector.
      legal: 'Documenti contrattuali',
    },
  },
  homebase: {
    // The owner's own details, asked for on Suite Home until given (issue 812); skipping asks first.
    ownDetails: {
      save: 'Salva i miei dati',
      later: 'Più tardi',
      saved: 'Grazie — i tuoi dati sono stati salvati.',
      skip: {
        title: 'Saltare i tuoi dati?',
        body: 'Finché non compili i tuoi dati, il tuo record in Personale resta non confermato. Significa: non si possono aggiungere dati da dipendente come contratto, ferie o paga, non puoi essere indicato come responsabile di nessuno e in Personale compari come «non confermato». Puoi farlo quando vuoi: questo promemoria tornerà domani.',
        fill: 'Compila ora',
        skip: 'Salta per ora',
      },
    },
    // The quiet "set up Lumi" panel on Suite Home: one fixed table of entries,
    // each a title + one benefit line; the rows are looked up per entry key.
    setup: {
      title: 'Configura lumi',
      subtitle: 'Niente di tutto questo è obbligatorio. Tutto vale la pena quando sei pronto.',
      hide: 'Non mi serve più',
      viewAll: 'Scopri tutto ciò che lumi sa fare',
      rareHeading: 'Usato più raramente',
      page: {
        title: 'Cosa sa fare lumi.',
        subtitle: 'Tutto ciò che si può configurare. Prima il più importante, il resto quando serve.',
        tipsTitle: 'Suggerimenti nella home',
        tipsShown: 'Il pannello resta in alto nella tua home finché non ti serve più.',
        tipsHidden: 'Hai nascosto il pannello. Qui lo riporti indietro.',
        emptyTitle: 'Qui non c\'è nulla da configurare per te.',
        emptyBody: 'Ciò che si può configurare viene gestito dai responsabili del tuo team. Chiedi a loro se manca qualcosa.',
      },
      sections: {
        suite: 'Home',
        ats: 'Recruiting',
        time: 'Tempo',
        people: 'Personale',
        apprentice: 'Ausbildung',
      },
      entries: {
        login_branding: { title: 'Personalizza la pagina di accesso', hint: 'Logo e colori, così il tuo team capisce di essere nel posto giusto.' },
        portal_design: { title: 'Personalizza il portale carriere', hint: 'È così che i candidati vedono per primi la tua azienda.' },
        email_templates: { title: 'Modelli di e-mail', hint: 'Conferma di ricezione, invito, rifiuto: si scrive una volta e si usa sempre.' },
        job_posting_settings: { title: 'Dati per gli annunci di lavoro', hint: 'Logo e referente. I portali di lavoro esterni richiedono entrambi.' },
        work_time_models: { title: 'Modelli di orario di lavoro', hint: 'Chi lavora quante ore e in quali giorni.' },
        company_holidays: { title: 'Chiusure aziendali', hint: 'I giorni in cui l\'azienda è chiusa.' },
        data_import: { title: 'Importa persone', hint: 'Riprendi gli elenchi esistenti invece di digitare tutto.' },
        company_profile: { title: 'Profilo aziendale', hint: 'Indirizzo e dati essenziali che lumi usa in molti punti.' },
        org_units: { title: 'Unità organizzative', hint: 'Reparti e sedi in base ai quali si ordina molto.' },
        payroll_handover: { title: 'Consegna paghe (DATEV)', hint: 'lumi fornisce le ore, il tuo consulente paghe calcola la retribuzione.' },
        training_occupations: { title: 'Professioni di formazione', hint: 'Quali professioni formate.' },
        workflows: { title: 'Workflow', hint: 'Passaggi e approvazioni propri nel processo di selezione.' },
        application_forms: { title: 'Moduli di candidatura', hint: 'A quali domande rispondono i candidati.' },
        offer_templates: { title: 'Modelli di offerta', hint: 'Preparare offerte contrattuali con segnaposto.' },
        custom_fields: { title: 'Campi personalizzati', hint: 'Dati aggiuntivi su posizioni e candidature.' },
        booking_types: { title: 'Tipi di registrazione', hint: 'Cosa si può registrare oltre all\'orario di lavoro.' },
        leave_types: { title: 'Tipi di assenza', hint: 'Ferie, malattia e i vostri tipi.' },
        api_settings: { title: 'Interfaccia (API)', hint: 'Passare i tempi ai propri programmi tramite l’API. La consegna paghe è in Personale.' },
        time_clock: { title: 'Timbratrice', hint: 'Aprirla nel browser di un tablet in sede: ogni persona accede con il proprio account lumi e timbra l\'entrata o l\'uscita.' },
        sso: { title: 'Single Sign-on', hint: 'Accesso con l\'account aziendale.' },
        onboarding_templates: { title: 'Modelli di inserimento', hint: 'Liste di controllo per i primi giorni dei nuovi colleghi.' },
        recruiting_options: { title: 'Elenchi di opzioni', hint: 'Titoli di cortesia, tipi di contratto e sedi di lavoro tra cui sceglie il vostro team.' },
      },
    },
    greeting: { morning: 'Buongiorno', day: 'Ciao', evening: 'Buonasera' },
    // La riga della data sotto il saluto ("Lunedì 21 settembre · Sett. 39",
    // workspace-start M2) sostituisce il sottotitolo statico.
    dateLine: { week: 'Sett. {n}' },
    open: 'Apri',
    recents: 'Recenti',
    recentKinds: { report: 'Report settimanale', job: 'Posizione', application: 'Candidatura' },
    moreActions: 'Altre azioni',
    clockedInSince: 'Timbrato dalle {time}',
    clockedOut: 'Uscita timbrata',
    clockOut: 'Timbra uscita',
    clockIn: 'Timbra entrata',
    projectRunning: 'Tempo di progetto in corso',
    projectRunningSince: 'Dalle {time}',
    startProject: 'Avvia un progetto',
    // The clock tile for a person freed from booking working time (issue 981): the sentence, then the way to a project.
    workTimeFree: 'Secondo il tuo contratto registri solo il tempo di progetto, non l\'orario di lavoro.',
    // The Stempeluhr's project choice once clocked in (Zeit's "Woran arbeitest du?"): the tile's field and its sheet.
    clockProject: {
      title: 'A cosa stai lavorando?',
      none: 'Senza progetto',
      noneSub: 'Conta come «Non assegnato»',
      choose: 'Scegli progetto e attività',
      fieldLabel: 'A cosa stai lavorando? Ora: {current}',
      runningWith: '{activity} · dalle {time}',
      runningSince: 'Dalle {time}',
      activityStep: 'Quale attività?',
      back: 'Tutti i progetti',
      defaultActivity: 'Predefinita',
      search: 'Cerca progetto',
      noMatch: 'Nessun progetto trovato',
      close: 'Chiudi',
    },
    provisioning: 'Configurazione in corso — può richiedere un minuto.',
    preferences: 'Preferenze',
    seeMyOrg: 'La mia organizzazione',
    // What each module Lumi still sells actually does (issue 261 M2). Longer than the
    // launcher's one-liners (app-kit's `lumiModules.<key>.description`): this is one
    // app, so the home can say it in the module's own vocabulary.
    teaser: {
      about: {
        ats: 'Annunci di lavoro, candidature e pipeline di selezione: dal primo CV al contratto firmato.',
        time_tracking: 'Timbrature, conti ore, assenze e straordinari, pronti per il registro delle presenze.',
        apprenticeship: 'Libretti di formazione digitali, piani formativi e valutazioni per ogni apprendista.',
      },
      heading: 'Altri moduli',
    },
    empty: 'Qui non c’è ancora nulla: apri il modulo per iniziare.',
    unavailable: 'Non è possibile caricare in questo momento.',

    goToModule: 'Vai a {module}', expand: 'Espandi {module}', collapse: 'Comprimi {module}',
    themeLight: 'Chiaro',
    themeDark: 'Scuro',
    people: { selfService: 'I miei dati' },
    myDocuments: {
      title: 'I miei documenti',
      downloadFailed: 'Download non riuscito – riprova più tardi.',
      showAll: 'Mostra tutti ({count})',
      showLess: 'Mostra meno',
      handIn: 'Consegna un documento',
      empty: 'Ancora nulla. Puoi consegnare un certificato, un attestato, un certificato di malattia o una copia del documento di identità per il tuo fascicolo.',
      kindLabel: 'Di cosa si tratta?',
      fileLabel: 'File – scegli o scatta una foto',
      send: 'Invia',
      cancel: 'Annulla',
      handedIn: 'Consegnato il {date} · in attesa delle RU',
      accepted: 'Consegnato il {date} · accettato',
      sentBack: 'Restituito il {date}: «{reason}»',
      handInAgain: 'Consegna di nuovo',
      dismiss: 'Nascondi',
      error: {
        file_refused: 'Questo file non è stato accettato – prova con un altro file.',
        file_too_large: 'Questo file è troppo grande – il limite è 25 MB.',
        file_empty: 'Questo file è vuoto – scegli un altro file.',
        file_missing: 'Scegli prima un file.',
        quota_exceeded: 'Il tuo fascicolo ha raggiunto il limite di spazio – contatta le RU.',
        invalid_category: 'Scegli che tipo di documento è.',
        not_possible: 'Al momento non è possibile consegnare – contatta le RU.',
        generic: 'Consegna non riuscita – riprova più tardi.',
        scan_unavailable: 'Al momento non è stato possibile controllare il file. Riprova tra poco.',
      },
      category: {
        contract: 'Contratto di lavoro',
        contract_amendment: 'Modifica contrattuale',
        certificate: 'Certificato di lavoro',
        attestation: 'Attestato',
        payslip: 'Busta paga',
        health_certificate: 'Certificato di malattia / medico',
        identification: 'Documento di identità',
        other: 'Altro',
      },
    },
    admin: {
      users: 'Utenti',
      usersMoved: {
        title: 'La gestione degli utenti è stata spostata in Personale',
        redirecting: 'Apertura di Personale…',
        noPeople: 'Chi ha accesso a questo workspace si gestisce sulla scheda di ogni persona in Personale. Personale non è disponibile per te qui: rivolgiti al proprietario del workspace.',
      },
    },
    verwaltung: { heading: 'Amministrazione' },
    nav: { home: 'Dashboard', billing: 'Fatturazione', logout: 'Esci', language: 'Lingua', administration: 'Amministrazione', sso: 'Single Sign-On', audit: 'Registro di controllo', supportAccess: 'Accesso del supporto', aiUsage: 'Utilizzo IA', dataProcessing: 'Trattamento dei dati', dataRequests: 'Richieste degli interessati', legalNotices: 'Note legali', statutoryRules: 'Norme di legge', trainingOccupations: 'Professioni di formazione', externalAgents: 'Agenti IA esterni', setup: 'Configura' },
    // The running week against its Sollstunden (#403). `hoursUnit` is a
    // separate key because the figures are formatted with Intl and the unit
    // trails them in every language this app ships.
    week: {
      title: 'Questa settimana',
      hoursUnit: 'h',
      balance: 'Conto ore, al {date}: {balance}',
      balanceHint: 'Ore lavorate meno ore dovute fino a quel giorno.',
      noTarget: 'Nessun orario settimanale definito.',
      trustBased: 'Lavori con orario di lavoro basato sulla fiducia: registri quando inizi e quando finisci, e per te non ci sono né obiettivo né conto ore.',
      projectsMore: 'e altri {n}',
      days: 'Giorni della settimana',
    },
    heute: {
      clock: 'Timbratrice',
      attention: 'Ti riguarda',
      news: 'Nuovo',
      leaveRemaining: 'Ferie rimanenti',
      days: 'Giorno | Giorni',
      kind: { interview: 'Colloquio', leave: 'Assenze', holiday: 'Festività', exam: 'Esame', station: 'Rotazione' },
    },
    facts: {
      ats: { total_jobs: 'Posizioni', total_applications: 'Candidature', open_tasks: 'Attività aperte', new_applicants: 'Nuovi candidati', create_job: 'Crea posizione', add_application: 'Aggiungi candidatura', create_task: 'Crea attività', pipeline: 'Pipeline', pipeline_closed: '{n} chiuse', stage_other: 'Altre' },
      time: { week_hours: 'Ore questa settimana', today_hours: 'Ore oggi', timesheet: 'Il mio foglio ore', request_leave: 'Richiedi permesso', approvals: 'Approvazioni', team: 'Team', pending_approvals: 'Approvazioni in sospeso', leave_remaining: 'Ferie rimanenti' },
      apprentice: { waiting: 'Da rivedere', active: 'Apprendisti', overdue: 'Settimane mancanti', this_week: 'Questa settimana', badges: 'Competenze', write: 'Compila la settimana', skills: 'Muro delle competenze', review: 'Rivedi i rapporti', onboard: 'Aggiungi apprendista', reports: 'Libretti di rapporto', report_approved: 'Approvati', report_submitted: 'Da rivedere', report_rejected: 'Restituiti', report_missing: 'Mancanti' },
    },
  },
  preferences: {
    appearance: 'Aspetto',
    theme: 'Tema',
    themeHint: 'Interfaccia chiara o scura.',
    language: 'Lingua',
    languageHint: 'La lingua usata nell’intero spazio.',
    attributions: 'Attribuzioni dei dati aperti',
    placesCredit: 'Dati sui luoghi © {source}, concessi in licenza {licence}.',
    bankCodesCredit: "Codici bancari: fonte {bundesbank}; codici bancari austriaci © {oenb}, concessi in licenza {licence}; codici svizzeri e del Liechtenstein © {six}.",
    healthInsurersCredit: "Casse malattia: file anagrafico della previdenza sociale del {gkv}.",
  },
  onboarding: {
    actions: { add: 'Aggiungi', back: 'Indietro', next: 'Avanti', remove: 'Rimuovi' },
    modules: {
      ats: 'Recruiting',
      time_tracking: 'Tempo',
      apprenticeship: 'Ausbildung',
    },
    fork: {
      // The headline is two keys: the lead and `titleMark`, the final beat that sits
      // on the highlighter stroke. The mark is always the LAST beat of the sentence.
      eyebrow: 'Ti diamo il benvenuto in lumi',
      title: 'Che bello che tu sia',
      titleMark: 'qui.',
      subtitle: 'Come vuoi iniziare? Puoi cambiare quando vuoi.',
      // From a live demo the same page is the way out of it.
      eyebrowDemo: 'Fuori dalla demo',
      titleDemo: 'Hai esplorato abbastanza.',
      titleDemoMark: 'Ora sul serio.',
      subtitleDemo: 'Con la configurazione guidata l’azienda dimostrativa resta lì finché non hai finito.',
      reassure: 'Hai dei dubbi? Inizia con la demo: alla configurazione reale passi quando vuoi.',
      seedFailed: 'La preparazione dei dati dimostrativi non è stata completata. Riprova.',
      seedFailedNotEmpty:
        'La demo richiede moduli vuoti, ma uno dei tuoi contiene già dei dati. Rimuovili prima, oppure scegli «Configura la tua suite».',
      // #364 F19: why the fork opened mid-Finish. The wizard hands an admin back
      // here when the AVV is still unsigned; landing with nothing said is what
      // made a refused Finish read as a silent drop.
      avvRequiredNotice:
        'La configurazione non può essere completata finché non accetti l’accordo sul trattamento dei dati (AVV). Accettalo qui e tornerai subito alla guida alla configurazione.',
      // #364 F21 / ADR 0032 Decision 2: the fork is now also reached FROM a live
      // demo, so it needs the wizard's way out. Leaving costs nothing.
      backToDemo: 'Torna alla demo',
      demo: {
        eyebrow: 'Prova',
        title: 'Esplora con dati dimostrativi',
        body: 'Riempiamo i tuoi moduli con un’azienda fittizia e coerente. Clicca dappertutto senza rompere niente.',
        modulesHint: 'I moduli acquistati sono sempre inclusi.',
        cta: 'Esplora la demo',
      },
      guided: {
        eyebrow: 'Configura',
        title: 'Guidami passo dopo passo',
        body: 'Passo dopo passo verso la tua suite reale. Fai una pausa, salta un passaggio o passa prima dalla demo: si può tutto.',
        bodyDemo: 'Passo dopo passo verso la tua suite reale. Se chiudi la finestra, torni nella demo.',
        pointSaved: 'I tuoi progressi vengono salvati',
        pointOptional: 'Ogni passaggio è facoltativo',
        cta: 'Guidami passo dopo passo',
      },
      empty: {
        eyebrow: 'Fai da te',
        titleFresh: 'Inizia da zero',
        titleDemo: 'Scarta la demo e inizia da zero',
        bodyFresh: 'Una tela bianca. Configuri tutto a poco a poco, con i tuoi tempi.',
        bodyDemo: 'L’azienda dimostrativa viene eliminata e parti da una base vuota.',
        warnDemo: 'Succede subito e non si può annullare.',
        cta: 'Inizia da zero',
      },
    },
    exitGate: {
      title: 'Prima di lasciare la demo',
      intro: 'Ecco cosa ha prenotato il tuo spazio di lavoro e a che punto è il tuo periodo di prova. Aggiungi un modulo ora o più tardi da Fatturazione: la configurazione funziona in entrambi i casi.',
      booked: { title: 'Prenotato' },
      // The colleagues invited from the demo bar, named before the owner ends the demo
      // (issue 669); `fallback` stands in when the roster could not be read.
      guests: {
        title: 'Colleghi invitati alla demo',
        lead: 'Questi colleghi perdono l’accesso quando la demo termina:',
        fallback: 'I colleghi che hai invitato alla demo perdono l’accesso quando termina.',
        people: 'Il tuo vero team lo inviti da Personale quando lo spazio di lavoro è configurato.',
      },
      // What only the gate can say about a module booked at it (#409 F12): whether
      // its setup-guide section is there yet. The booking rows themselves are the
      // billing section's.
      bookedHere: {
        settingUp: 'Preparazione di {module}…',
        booked: '{module} è prenotato e ha una sezione propria nella guida alla configurazione.',
        bookedPending: '{module} è prenotato. La sua sezione comparirà nella guida alla configurazione non appena il modulo sarà pronto.',
      },
      noManage: 'Solo il proprietario dello spazio di lavoro, un responsabile della fatturazione o un amministratore dello spazio possono prenotare moduli. Puoi comunque continuare senza prenotare.',
      enforcement: 'C’è un pagamento in sospeso in questo spazio di lavoro. Le prenotazioni sono in pausa finché non viene saldato; la configurazione della tua suite no.',
      factsUnavailable: 'Non siamo riusciti a caricare la tua prenotazione in questo momento. Puoi comunque continuare; trovi tutto nella pagina Fatturazione.',
      trial: {
        title: 'Il tuo periodo di prova',
        range: 'Il tuo periodo di prova è iniziato il {start} e termina il {end}.',
        endOnly: 'Il tuo periodo di prova termina il {end}.',
        rangeFree: 'Gratis dal {start} al {end}.',
        endOnlyFree: 'Gratis fino al {end}.',
        charge: 'Dal {end} vengono addebitati {amount} al mese per quanto hai prenotato, all’inizio di ogni mese di fatturazione.',
        chargeNoTotal: 'Dal {end} la tua prenotazione viene addebitata mensilmente, all’inizio di ogni mese di fatturazione.',
        firstCharge: 'Il primo addebito è il {date}.',
        demoCounted: 'Il tempo trascorso nella demo è stato conteggiato nel tuo periodo di prova.',
        over: 'Il tuo periodo di prova è terminato e la tua prenotazione viene fatturata mensilmente.',
        monthly: 'Sono {amount} al mese.',
        nextCharge: 'Il prossimo addebito è il {date}.',
      },
      continue: 'Continua con la configurazione',
    },
    avv: {
      modalTitle: 'Accetta l’accordo sul trattamento dei dati (AVV)',
      modalBody:
        'Configurare la tua suite con dati reali significa che lumi tratta dati personali per tuo conto. Prima di continuare, leggi e accetta il nostro attuale accordo sul trattamento dei dati (AVV).',
      modalLinkText: 'Leggi l’AVV completo',
      modalCheckboxLabel: 'Ho letto e accetto l’AVV attuale.',
      modalCancel: 'Non ancora',
      modalAccept: 'Accetta e continua',
    },
    preparing: {
      first: {
        title: 'La tua demo è in preparazione.',
        body: 'Stiamo creando un’azienda fittizia e coerente in tutti i tuoi moduli. Ci vuole solo un attimo.',
      },
      reset: {
        title: 'La tua demo viene ripristinata.',
        body: 'Stiamo svuotando l’azienda dimostrativa e ricreandola da zero. Il tuo spazio di lavoro e i tuoi colleghi non vengono toccati. Ci vuole solo un attimo.',
      },
      stuck: {
        note: 'Sta impiegando più tempo del previsto.',
        cta: 'Configura manualmente',
      },
    },
    nonAdmin: {
      title: 'Ci siamo',
      titleMark: 'quasi.',
      body: 'Il tuo amministratore o la tua amministratrice sta ancora configurando la suite. Appena avrà finito, entrerai direttamente da qui.',
    },
    wizard: {
      title: 'Configura la tua suite',
      subtitle: 'Qui è tutto facoltativo e i tuoi progressi vengono salvati. Configura ciò che vuoi, completa la configurazione oppure torna alla demo chiudendo questa finestra.',
      subtitleCommitting: 'La tua configurazione è in fase di applicazione. Se un passaggio non riesce, puoi saltarlo e configurarlo più tardi nelle impostazioni.',
      crossRef: 'Usato in {modules} — modificabile più tardi in {owner}.',
      crossRefOwnerDefault: 'Personale',
      recovery: 'Non è stato possibile applicare «{step}». Controlla lì i tuoi dati e completa di nuovo.',
      details: {
        step: 'I tuoi dati',
        title: 'I tuoi dati',
        subtitle: 'Il tuo record personale in Personale. Controlla il tuo nome: salvandolo confermi il tuo record.',
        loading: 'Caricamento del tuo record…',
        confirmed: 'Il tuo record è confermato come {name}. Puoi modificarlo in seguito in Personale.',
        unavailable: 'Al momento non è stato possibile caricare il tuo record. Puoi confermarlo in seguito in Personale.',
        firstName: 'Nome',
        lastName: 'Cognome',
        required: 'Inserisci nome e cognome.',
        hq: {
          title: 'La vostra sede',
          why: 'Lumi non può fare a meno di una sede: ha bisogno della vostra sede principale come prima sede, ad esempio per i vostri annunci di lavoro.',
          street: 'Via',
          postalCode: 'CAP',
          city: 'Città',
          country: 'Paese',
          countryNone: 'Nessun paese selezionato',
          required: 'Inserisci via, CAP, città e paese della vostra sede principale.',
        },
      },
      general: {
        title: 'Generale',
        company: {
          title: 'Profilo aziendale',
        },
        name: {
          label: 'Nome azienda',
          hint: 'Precompilato dal checkout — modifica se necessario. Obbligatorio.',
          required: 'Il nome dell’azienda è obbligatorio.',
        },
        profile: {
          industry: 'Settore',
          employeeCountRange: 'Dimensioni dell’azienda',
          employeeCountPlaceholder: 'es. 50–200',
          foundedYear: 'Fondata',
          foundedYearPlaceholder: 'es. 2010',
          legalForm: 'Forma giuridica',
          websiteUrl: 'Sito web',
        },
        place: {
          hint: 'Scegli una città dall’elenco come nome della sede, oppure scrivi un nome tuo e conferma con Invio o +.',
        },
        org: {
          title: 'Struttura organizzativa',
          subtitle: 'Reparti, sedi e centri di costo a cui appartengono le tue persone.',
          departments: 'Reparti',
          locations: 'Sedi',
          costCenters: 'Centri di costo',
          empty: 'Ancora nessuno',
          addDepartment: 'Nuovo reparto',
          addLocation: 'Nuova sede, ad es. Milano',
          addCostCenter: 'Nuovo centro di costo',
        },
      },
      finish: {
        cta: 'Termina la configurazione',
        step: 'Fine',
        title: 'Termina la configurazione',
        body: 'Al termine vengono applicate le tue risposte. Potrai modificare tutto più tardi in ogni modulo.',
        nextTitle: 'Poi: invita il tuo team',
        nextBody: 'Dopo la configurazione, apri l’area di amministrazione per invitare i primi utenti e assegnare i loro ruoli.',
        demoWarning: 'Al termine vengono eliminati l’azienda dimostrativa e tutti gli utenti invitati durante l’esplorazione.',
      },
      sections: {
        ats: {
          title: 'Recruiting',
          subtitle: 'Imposta il funzionamento delle candidature e delle e-mail di selezione.',
          fields: {
            fromName: { label: 'Nome mittente', hint: 'Mostrato nelle e-mail ai candidati.' },
            signature: { label: 'Firma e-mail', hint: 'Aggiunta alle e-mail in uscita verso i candidati.' },
          },
          jobPosting: {
            title: 'Annuncio di lavoro',
            hint: 'Il contatto di candidatura e il logo mostrati negli annunci di lavoro esterni (facoltativo — puoi configurarlo anche più tardi).',
            contactName: 'Nome del contatto',
            contactEmail: 'E-mail di contatto',
            logo: 'Logo dell’annuncio',
            uploadLogo: 'Carica logo',
            removeLogo: 'Rimuovi',
            rePick: 'Il tuo logo non è ancora stato caricato — selezionalo di nuovo.',
            contactEmailInvalid: 'Inserisci un indirizzo e-mail valido.',
          },
          workflow: {
            title: 'Processo di selezione',
            participantsQuestion: 'Chi è coinvolto negli annunci di lavoro e nelle candidature?',
            worksCouncil: 'Consiglio aziendale',
            sbv: 'Rappresentanza dei lavoratori con disabilità',
            legalSignOff: 'Ufficio legale – approva un annuncio di lavoro prima della pubblicazione',
            assessmentCentreQuestion: 'Utilizzate assessment center?',
            assessmentCentre: 'Sì, utilizziamo assessment center',
            hint: 'Puoi modificare e aggiornare il processo in qualsiasi momento più avanti nell’ATS.',
          },
        },
        time_tracking: {
          title: 'Tempo',
          subtitle: 'Tipi di registrazione e regole sull’orario di lavoro.',
          fields: {
            bookingTypes: { label: 'Tipi di registrazione', hint: 'Aggiungi i tipi di registrazione che usi.', placeholder: 'es. Lavoro' },
          },
          companyHolidays: {
            title: 'Chiusure aziendali',
            hint: 'Giorni in cui l’azienda è chiusa, per esempio mezza giornata alla vigilia di Natale e a San Silvestro. In quei giorni non maturano ore previste. Per ogni voce decidi se viene scalata dalle ferie; potrai cambiarlo più tardi nelle impostazioni di Tempo.',
            empty: 'Nessuna chiusura aziendale inserita.',
            suggestions: 'Suggerimenti:',
            christmasEve: 'Vigilia di Natale',
            newYearsEve: 'San Silvestro',
            name: 'Nome',
            namePlaceholder: 'es. Tra Natale e Capodanno',
            from: 'Dal',
            to: 'Al (facoltativo)',
            halfDay: 'Mezza giornata',
            yearly: 'Ogni anno',
            deductsFromLeave: 'Scala dalle ferie',
            rangeReversed: 'La data di fine precede quella di inizio.',
          },
        },
        apprenticeship: {
          title: 'Ausbildung',
          subtitle: 'Professioni di formazione.',
          fields: {
            professions: { label: 'Professioni di formazione', hint: 'Le professioni di apprendistato per cui formi.', placeholder: 'es. Tecnico informatico' },
          },
        },
        people: {
          title: 'Personale',
          subtitle: 'Terminologia condivisa usata in tutta la suite.',
          fields: {
            salutations: { label: 'Appellativi', hint: 'Aggiungi appellativi oltre al set standard.', placeholder: 'es. Mx' },
            contractTypes: { label: 'Tipi di contratto', hint: 'Aggiungi tipi di contratto oltre al set standard.', placeholder: 'es. Studente lavoratore' },
            workTimeModels: { label: 'Modelli di orario', hint: 'Aggiungi modelli oltre al set standard.', placeholder: 'es. Job sharing' },
            workLocationTypes: { label: 'Luoghi di lavoro', hint: 'Aggiungi tipi di luogo di lavoro oltre al set standard.', placeholder: 'es. Lavoro esterno' },
          },
        },
      },
    },
    commit: {
      wiping: {
        title: 'Cancellazione della demo…',
        body: 'Rimozione dell’azienda dimostrativa perché la tua configurazione reale parta pulita.',
      },
      applying: {
        title: 'Configurazione della tua suite…',
        body: 'Applicazione delle tue risposte. Ci vuole solo un attimo.',
      },
      steps: {
        company: 'Profilo aziendale',
      },
      error: 'Si è verificato un problema durante l’applicazione della tua configurazione.',
      retry: 'Riprova',
      backToSetup: 'Torna alla configurazione',
      skipStep: 'Completa senza questo passaggio',
      skipped: 'Saltato: {steps}. Puoi configurarlo in qualsiasi momento nelle impostazioni.',
      resume: 'Riprendi la configurazione',
      stalled: 'Sta impiegando più tempo del previsto.',
      wipeFailed: 'Impossibile cancellare la demo. Riprova per continuare.',
      logoMissing: 'Il tuo logo non è stato caricato (perso al ricaricamento) — puoi aggiungerlo più tardi nelle impostazioni degli annunci di lavoro.',
      workflowFailed: 'Non è stato possibile generare la tua catena di selezione, quindi il tuo spazio di lavoro parte dalla catena standard. Tutto il resto è stato applicato: apri le impostazioni del workflow in Selezione per eseguire di nuovo il generatore.',
      workflowDrafted: 'Il tuo processo di selezione è stato salvato come bozza perché {roles} non ha ancora nessuno assegnato. Apri le impostazioni del workflow in Selezione per attivarlo non appena il ruolo è coperto.',
      workflowRoles: {
        ats_works_council: 'la rappresentanza dei lavoratori',
        ats_sbv: 'la rappresentanza delle persone con disabilità',
        ats_legal: 'l’ufficio legale',
      },
      continue: 'Continua allo spazio di lavoro',
    },
  },
  tenants: {
    switcherLabel: 'Cambia spazio di lavoro',
    supportAccessBadge: 'Supporto',
    supportAccessUntil: 'Accesso temporaneo del supporto fino al {until}',
    supportAccessBanner: 'Il supporto lumi ha attualmente accesso temporaneo a questo spazio.',
    supportAccessReview: 'Esamina',
  },
  dataProtection: {
    blockedErasure: {
      title: 'Cosa blocca una cancellazione',
      intro: 'I documenti del fascicolo personale senza termine di conservazione vengono conservati a tempo indeterminato: nessuno ha stabilito per quanto tempo vadano tenuti, e un documento non deciso non viene mai cancellato automaticamente. Qui li trovi elencati, così puoi impostare i termini.',
      sensitivePlaceholder: 'Documento sensibile',
      categories: {
        contract: 'Contratto',
        contract_amendment: 'Modifica contrattuale',
        certificate: 'Certificato',
        attestation: 'Attestazione',
        warning: 'Richiamo',
        other: 'Altro documento',
      },
      outcomes: {
        refused: 'Cancellazione rifiutata',
        partial: 'Cancellato in parte',
      },
      list: {
        title: 'Documenti senza termine di conservazione',
        fixHint: 'Prima i più vecchi. Imposta un termine di conservazione sul documento nel fascicolo personale e sparirà da questo elenco.',
        loading: 'Caricamento dei documenti…',
        loadError: 'Non è stato possibile caricare l’elenco. Riprova: non significa «nessun risultato».',
        empty: 'Ogni documento di questo spazio di lavoro ha un termine di conservazione.',
        uploadedLabel: 'Caricato il',
        truncated: 'Vengono mostrati solo i {count} documenti più vecchi. Altri attendono un termine di conservazione.',
      },
    },
    myData: {
      title: 'I miei dati',
      intro: 'Qui puoi chiedere quali dati questo spazio di lavoro conserva su di te, chiederne la rettifica o chiederne la cancellazione. Ogni richiesta viene registrata e gestita dalle persone responsabili della protezione dei dati in questo spazio, e puoi seguirla qui.',
      requests: {
        title: 'Le mie richieste',
        loading: 'Caricamento delle tue richieste…',
        loadError: 'Non è stato possibile caricare le tue richieste. Puoi comunque inviarne una qui sotto.',
        empty: 'Non hai ancora inviato nessuna richiesta.',
        filedLabel: 'Inviata',
        dueLabel: 'Risposta attesa',
        outcomeLabel: 'Esito',
        awaitingRelease: 'Copia in verifica',
      },
      kinds: {
        access: 'Copia dei miei dati',
        rectification: 'Rettifica',
        erasure: 'Cancellazione',
      },
      statuses: {
        received: 'Ricevuta',
        verifying: 'Verifica della tua identità',
        in_progress: 'In lavorazione',
        awaiting_subject: 'In attesa della tua risposta',
        completed: 'Conclusa',
        refused: 'Respinta',
        withdrawn: 'Ritirata',
      },
      outcomes: {
        erased: 'Dati cancellati',
        suppressed: 'Dati cancellati, resta una registrazione minima',
        refused: 'Respinta',
        partial: 'Parzialmente evasa',
        answered: 'Risposta fornita',
      },
      actions: {
        access: {
          title: 'Chiedere una copia dei miei dati',
          body: 'Puoi chiedere una copia dei dati che questo spazio di lavoro conserva su di te. Non è un download immediato: la copia viene prima preparata e ti viene comunicato quando è pronta.',
          where: 'Una copia pronta non viene mai inviata come allegato. Ricevi un messaggio e-mail, accedi al tuo account lumi HR e la scarichi da lì.',
          cta: 'Chiedi una copia',
          detailLabel: 'Qualcosa da aggiungere (facoltativo)',
          detailHint: 'Ad esempio se vuoi solo una parte dei tuoi dati.',
        },
        rectification: {
          title: 'Chiedere una rettifica',
          body: 'Se un dato che questo spazio di lavoro conserva su di te è errato o non è aggiornato, puoi chiederne la rettifica.',
          cta: 'Chiedi una rettifica',
          detailLabel: 'Che cosa è sbagliato e che cosa dovrebbe dire?',
          detailHint: 'Descrivi i dati nel modo più preciso possibile, così da poterli trovare e verificare.',
          selfTitle: 'Una parte puoi modificarla da te',
          selfFields: 'Il tuo nome e la formula di cortesia, il tuo genere, la tua e-mail di contatto, il tuo telefono, il tuo indirizzo, la tua cittadinanza, il tuo stato civile e la tua lingua li modifichi nel tuo profilo.',
          selfLink: 'Apri il mio profilo',
          askBody: 'Per tutto il resto – data di nascita, numero di matricola, dati contrattuali, retributivi o fiscali, i tuoi documenti – usa la richiesta qui sotto.',
        },
        erasure: {
          title: 'Chiedere la cancellazione dei miei dati',
          body: 'Puoi chiedere a questo spazio di lavoro di cancellare i dati che conserva su di te.',
          cta: 'Chiedi la cancellazione',
          confirm: 'La tua richiesta viene esaminata dalle persone responsabili in questo spazio di lavoro. I dati che devono essere conservati per legge, o che servono ancora per il tuo rapporto di lavoro, non possono essere cancellati. Ti viene comunicato che cosa è stato cancellato e che cosa resta.',
          detailLabel: 'Qualcosa da aggiungere (facoltativo)',
          detailHint: 'Ad esempio a quali dati ti riferisci, se non sono tutti.',
        },
      },
      form: {
        submit: 'Invia la richiesta',
        submitting: 'Invio…',
        cancel: 'Annulla',
        success: 'La tua richiesta è registrata. La trovi qui sopra in «Le mie richieste».',
        errorGeneric: 'Non è stato possibile inviare la tua richiesta. Non è stato registrato nulla: riprova.',
        errorRateLimit: 'Hai inviato più richieste in poco tempo. Riprova più tardi.',
      },
    },
    export: {
      title: 'Esporta questo spazio di lavoro',
      intro: 'Puoi scaricare in qualsiasi momento una copia completa di tutto ciò che questo spazio di lavoro conserva, in un formato leggibile da una macchina e senza chiedercelo.',
      contents: {
        title: 'Che cosa contiene questo file',
        body: 'L’archivio contiene i dati di tutte le persone in chiaro e, insieme a questi, le chiavi di accesso attive di questo spazio di lavoro: la chiave IA, i link dei calendari con i relativi token e le credenziali dei fornitori collegati. L’archivio contiene anche, per Personale, Recruiting e Tempo, un documento HR Open Standards (HR-JSON): il formato condiviso per portare i tuoi dati a un altro fornitore.',
        handling: 'Conservalo con la stessa cura che riservi a quelle chiavi. Chi ottiene il file e la password ottiene tutto ciò che contiene.',
      },
      roleRequired: {
        title: 'Questa esportazione richiede il ruolo «Protezione dei dati»',
        body: 'L’archivio contiene ogni file conservato in questo spazio di lavoro — buste paga, certificati medici e documenti d’identità compresi — accanto ai dati personali di tutti e alle chiavi di accesso attive di questo spazio di lavoro.',
        hint: 'Essere proprietario dello spazio di lavoro non basta più: chi avvia l’esportazione deve avere anche il ruolo «Protezione dei dati». Il ruolo si assegna insieme agli altri ruoli della suite nell’amministrazione utenti e può essere assegnato anche a te.',
      },
      start: {
        title: 'Avvia un export',
        body: 'Scegli una password. L’archivio viene cifrato con quella password ed è l’unica che permette di aprirlo.',
        passphraseWarning: 'Non conserviamo mai la tua password e non possiamo recuperarla. Se la perdi, l’archivio non può più essere aperto: non esiste alcun ripristino.',
        passphraseLabel: 'Password',
        passphraseHint: 'Almeno {min} caratteri. Scegli qualcosa di lungo che puoi conservare al sicuro.',
        confirmLabel: 'Ripeti la password',
        submit: 'Avvia export',
        submitting: 'Avvio…',
        success: 'L’export è stato avviato. Viene preparato in background e comparirà qui sotto quando sarà pronto.',
        errorTooShort: 'La password deve avere almeno {min} caratteri.',
        errorMismatch: 'Le due password non coincidono.',
        errorAlreadyRunning: 'Un export di questo spazio di lavoro è già in corso. Aspetta che finisca prima di avviarne un altro.',
        errorTooMany: 'Questo spazio di lavoro ha avviato per il momento il numero massimo di export. Riprova più tardi.',
        errorGeneric: 'Non siamo riusciti a confermare che l’export sia stato avviato. Controlla l’elenco qui sotto prima di avviarne un altro.',
      },
      list: {
        title: 'Export di questo spazio di lavoro',
        loading: 'Caricamento degli export…',
        loadError: 'Non è stato possibile caricare gli export.',
        empty: 'Questo spazio di lavoro non è ancora stato esportato.',
        linkHint: 'Un link di download è valido solo per pochi istanti. Se smette di funzionare, usa di nuovo il pulsante.',
        retentionHint: 'Ogni archivio viene eliminato automaticamente alla scadenza: la data è indicata accanto.',
        startedLabel: 'Avviato',
        expiresLabel: 'Disponibile fino al',
        download: 'Scarica',
        preparing: 'Preparazione…',
        downloadError: 'Non è stato possibile preparare il download. L’archivio potrebbe non esserci più.',
        gone: 'L’archivio è stato eliminato. Avvia un nuovo export se ti serve un’altra copia.',
        failedHint: 'Questo export non è stato completato. Puoi avviarne uno nuovo.',
        runningHint: 'Questo export è ancora in preparazione.',
      },
      statuses: {
        requested: 'Richiesto',
        exporting: 'In preparazione',
        exported: 'Pronto',
        failed: 'Non riuscito',
        expired: 'Eliminato',
      },
    },
    settingsPanel: {
      title: 'Trattamento dei dati',
      body: 'Puoi chiedere la cancellazione o la correzione dei tuoi dati, oppure richiederne una copia, {link}.',
      linkLabel: 'qui',
    },
  },
  // Administration › Data subject requests (issue 789): the DSAR work list.
  dataRequests: {
    forbidden: {
      title: 'Questo elenco è per il ruolo di protezione dei dati',
      description: 'Le richieste degli interessati sono gestite dal titolare dello spazio di lavoro o da chi ha il ruolo «Protezione dei dati».',
    },
    intro: {
      title: 'Richieste degli interessati',
      body: 'Le richieste delle persone sui dati che questo spazio di lavoro conserva su di loro. A ciascuna va data risposta entro un mese dal ricevimento (art. 12, par. 3 del GDPR). Se la richiesta è complessa, il termine può essere prorogato due volte di un mese, con un motivo da comunicare alla persona.',
    },
    filters: {
      label: 'Mostra richieste',
      open: 'Aperte',
      overdue: 'In ritardo',
      dueSoon: 'In scadenza entro 7 giorni',
      closed: 'Evase di recente',
    },
    empty: {
      title: 'Nessuna richiesta degli interessati',
      description: 'Quando qualcuno chiede dei propri dati — in lumi, via e-mail, posta o telefono — la richiesta compare qui con la sua scadenza.',
    },
    emptyFilter: 'Nessuna richiesta in questa vista.',
    truncated: 'Non tutte le richieste stanno in questa pagina. Le scadenze più vicine sono mostrate per prime.',
    badges: {
      overdue: 'In ritardo',
      dueSoon: 'In scadenza',
      legalHold: 'Obbligo di conservazione',
      reviewReady: 'Pronto per la verifica',
      reviewReleased: 'Rilasciata',
      reviewDelivered: 'Consegnata',
    },
    row: {
      received: 'Ricevuta il',
      due: 'Risposta entro il',
      closed: 'Chiusa il',
      subject: 'Riguarda',
      channel: 'Arrivata tramite',
      outcome: 'Esito',
      extensions: 'Termine prorogato {count} volte su 2',
      postponed: 'Promemoria sospesi fino al {date}',
      vetoWindow: 'La cancellazione può ancora essere fermata fino al {date}',
      reviewFlagged: 'Serve la tua decisione: {flagged} voci su {total}',
      reviewNoneFlagged: 'Nessuna voce segnalata',
      reviewEmpty: 'La copia non contiene voci',
      reviewOpen: 'Verifica',
      reviewReleased: 'Rilasciata, in consegna',
      reviewDelivered: 'Consegnata, in chiusura',
    },
    legalHold: {
      tenant: 'Vale un obbligo di conservazione per tutto lo spazio di lavoro ({reason}).',
      subject: 'Un obbligo di conservazione riguarda questa persona ({reason}).',
      consequence: 'I dati non possono essere cancellati. La risposta lecita è un rifiuto che indichi proprio questo fondamento: l’obbligo non sospende il termine.',
    },
    automated: {
      pending: 'lumi risponde da sé a questa richiesta: dopo che hai verificato l’identità della persona e l’hai portata a «In lavorazione», lumi prepara la copia dei suoi dati. Poi la copia attende la tua verifica. Dopo il tuo rilascio la persona viene informata di dove scaricarla e la richiesta si chiude da sola.',
      running: 'lumi sta preparando la copia dei dati di questa persona. Poi attende la tua verifica: la persona saprà dove scaricarla solo dopo il tuo rilascio.',
    },
    detail: {
      show: 'Mostra chi l’ha presentata',
      hide: 'Nascondi dettagli',
      loading: 'Caricamento dei dettagli…',
      loadError: 'Non è stato possibile caricare i dettagli di questa richiesta.',
      subjectLabel: 'Nome indicato',
      subjectEmail: 'Indirizzo e-mail',
      subjectPhone: 'Numero di telefono',
      requestDetail: 'Cosa è stato chiesto',
      onBehalfReason: 'Registrata per suo conto perché',
      extensionReason: 'Motivo della proroga',
      outcomeBasis: 'Fondamento indicato',
      nothingOnFile: 'Contatto',
      nothingOnFileValue: 'Per questa richiesta non sono registrati nome, indirizzo né messaggio.',
    },
    kinds: {
      access: 'Copia dei propri dati',
      rectification: 'Rettifica',
      erasure: 'Cancellazione',
      restriction: 'Limitazione del trattamento',
      portability: 'Portabilità dei dati',
      objection: 'Opposizione al trattamento',
    },
    statuses: {
      received: 'Ricevuta',
      verifying: 'Verifica dell’identità',
      in_progress: 'In lavorazione',
      awaiting_subject: 'In attesa della persona',
      completed: 'Completata',
      refused: 'Respinta',
      withdrawn: 'Ritirata',
    },
    outcomes: {
      erased: 'Dati cancellati',
      suppressed: 'Dati cancellati, traccia minima conservata',
      refused: 'Respinta',
      partial: 'Evasa in parte',
      answered: 'Risposta completa',
    },
    subjectTypes: {
      person: 'Un fascicolo del personale',
      tenant_user: 'Un membro senza fascicolo del personale',
      candidate: 'Un candidato',
      unlinked: 'Non collegata a nessun record',
    },
    channels: {
      'self-service': 'Presentata in lumi dalla persona',
      'candidate-portal': 'Portale candidati',
      email: 'E-mail',
      post: 'Posta',
      phone: 'Telefono',
      unknown: 'Non registrato',
    },
    actions: {
      advance: {
        verifying: 'Verifica l’identità',
        in_progress: 'Inizia la lavorazione',
        awaiting_subject: 'Attendi la persona',
      },
      extend: 'Proroga il termine',
      close: 'Chiudi la richiesta',
      postpone: 'Sospendi promemoria',
      veto: 'Apri finestra di veto',
      hold: 'Conserva per questa persona',
      restrict: 'Limita il trattamento',
      record: 'Registra una richiesta',
    },
    confirmAutomated: {
      title: 'Preparare la copia dei dati di questa persona?',
      body: 'Portando la richiesta a «In lavorazione» incarichi lumi di raccogliere tutto ciò che questo spazio di lavoro conserva sulla persona. La copia non va ancora alla persona: attende la tua verifica, e la persona saprà dove scaricarla solo dopo il tuo rilascio. Fallo solo quando la sua identità è accertata.',
      confirm: 'Inizia',
    },
    toast: {
      advanced: 'Richiesta portata a «{status}».',
      extended: 'Termine prorogato al {date}.',
      closed: 'Richiesta chiusa.',
      postponed: 'Promemoria sospesi fino al {date}.',
      vetoOpened: 'Finestra di veto aperta. La cancellazione attende 72 ore.',
      holdPlaced: 'Obbligo di conservazione impostato.',
      holdReleased: 'Obbligo di conservazione revocato.',
      holdAttested: 'Obbligo di conservazione confermato per altri sei mesi.',
      restrictionPlaced: 'Trattamento limitato.',
      restrictionNotified: 'Comunicazione registrata.',
      restrictionLifted: 'Limitazione revocata.',
      recorded: 'Richiesta registrata.',
    },
    extend: {
      title: 'Proroga il termine',
      body: 'L’art. 12, par. 3 del GDPR consente due proroghe di un mese quando la richiesta è complessa o le richieste sono numerose. Informane la persona entro il primo mese, con il motivo.',
      remaining: 'Proroghe rimaste: {count}',
      reasonLabel: 'Motivo del ritardo',
      reasonHint: 'Viene registrato con la richiesta. Comunica alla persona lo stesso motivo.',
      submit: 'Proroga di un mese',
      errorReason: 'Indica il motivo del ritardo.',
    },
    close: {
      title: 'Chiudi la richiesta',
      body: 'Una richiesta chiusa non può essere riaperta: è la traccia di come e quando lo spazio di lavoro ha risposto.',
      statusLabel: 'Come è stata chiusa?',
      outcomeLabel: 'Cosa è stato fatto',
      outcomePlaceholder: 'Scegli…',
      basisLabel: 'Base giuridica',
      basisHint: 'Il fondamento di ciò che è stato conservato o rifiutato, ad esempio un obbligo di conservazione o l’art. 12, par. 5 del GDPR.',
      submit: 'Chiudi la richiesta',
      errorOutcome: 'Scegli cosa è stato fatto.',
      errorBasis: 'Un rifiuto o una risposta parziale deve indicare la base giuridica.',
      conflict: 'Non è stato possibile chiudere la richiesta così. Un obbligo di conservazione o una finestra di veto aperta può impedire la cancellazione dei dati, oppure la richiesta è cambiata nel frattempo: ricarica l’elenco e verifica.',
    },
    record: {
      title: 'Registra una richiesta',
      body: 'Per una richiesta arrivata via e-mail, posta o telefono. Il termine di un mese decorre dal giorno in cui è arrivata, non da oggi. Una richiesta registrata parte come ricevuta.',
      choose: 'Scegli…',
      kindLabel: 'Tipo di richiesta',
      channelLabel: 'Arrivata tramite',
      receivedLabel: 'Ricevuta il',
      receivedHint: 'Il giorno in cui la richiesta è arrivata allo spazio di lavoro — al più tardi oggi.',
      subjectLabel: 'Persona interessata',
      modes: {
        person: 'Una persona in Personale',
        candidate: 'Una candidatura in Recruiting',
        unlinked: 'Nessuna scheda',
      },
      personLabel: 'Cerca la persona',
      personHint: 'Cerca per nome o indirizzo e-mail.',
      candidateLabel: 'Candidato o candidata',
      candidateHint: 'Cerca per nome o indirizzo e-mail. Vengono trovati solo i candidati che il tuo ruolo in Recruiting può aprire.',
      candidateRefused: 'I tuoi ruoli in Recruiting non consentono di cercare candidature. Scegli «Nessuna scheda» e indica il nome dato dalla persona.',
      searchPlaceholder: 'Nome o indirizzo e-mail',
      picker: {
        searching: 'Ricerca…',
        typeMore: 'Almeno {count} caratteri',
        noMatch: 'Nessun risultato. Se la persona non è registrata da nessuna parte, scegli «Nessuna scheda».',
        error: 'La ricerca non è riuscita. Se la persona non è registrata da nessuna parte, scegli «Nessuna scheda».',
        refused: 'I tuoi ruoli non consentono di cercare candidature.',
        rateLimited: 'Troppe ricerche – si riprende tra poco',
        resultsAnnouncement: 'Un risultato | {count} risultati',
        clear: 'Rimuovi selezione',
      },
      nameLabel: 'Nome indicato',
      nameHint: 'Come la persona ha firmato o si è presentata.',
      emailLabel: 'Indirizzo e-mail (facoltativo)',
      detailLabel: 'Che cosa viene chiesto?',
      detailHint: 'Facoltativo. Il più possibile con le parole della persona.',
      reasonLabel: 'Perché la registri per suo conto?',
      reasonHint: 'Per esempio: lettera alle risorse umane del 3 maggio, o telefonata ricevuta alla reception. Viene registrato con il tuo nome.',
      submit: 'Registra richiesta',
      errorKind: 'Scegli il tipo di richiesta.',
      errorChannel: 'Scegli come è arrivata la richiesta.',
      errorReceived: 'Scegli il giorno in cui è arrivata la richiesta.',
      errorFuture: 'Una richiesta non può arrivare nel futuro. Scegli oggi o un giorno precedente.',
      errorPerson: 'Scegli la persona dalla ricerca, oppure «Nessuna scheda».',
      errorCandidate: 'Scegli la candidatura dalla ricerca, oppure «Nessuna scheda».',
      errorName: 'Indica il nome dato dalla persona.',
      errorEmail: 'Inserisci un indirizzo e-mail valido, oppure lascia vuoto il campo.',
      errorReason: 'Indica perché registri la richiesta per suo conto.',
    },
    errors: {
      conflict: 'Questo passaggio non è più possibile: la richiesta è cambiata nel frattempo. Ricarica l’elenco.',
      notLinked: 'Questa richiesta non è collegata a nessun record, quindi non c’è nessuno da conservare o limitare.',
    },
    progress: {
      title: 'Cancellazione per modulo',
      show: 'Mostra l’avanzamento della cancellazione',
      hide: 'Nascondi l’avanzamento della cancellazione',
      loading: 'Caricamento del registro di cancellazione…',
      loadError: 'Non è stato possibile caricare il registro di cancellazione.',
      unlinked: 'Questa richiesta non è collegata a nessun record, quindi nessun modulo ha cancellato nulla per essa.',
      lastExecuted: 'registrato il {date}',
      states: {
        done: 'Cancellato',
        heldNothing: 'Nessun dato conservato',
        pending: 'Non ancora registrato',
        deferred: 'Rinviato — modulo disattivato',
      },
      modules: {
        people: 'Personale',
        ats: 'Candidature',
        time: 'Tempo',
        apprentice: 'Apprendistato',
        payroll: 'Paghe',
        privacy: 'Registro protezione dati',
      },
    },
    postpone: {
      title: 'Sospendi i promemoria',
      body: 'Ferma le e-mail di promemoria fino al giorno scelto. Il termine di legge non si sposta: per spostarlo, proroga la richiesta.',
      untilLabel: 'Sospendi fino al',
      untilHint: 'Al più tardi la scadenza della risposta, il {date}.',
      reasonLabel: 'Motivo',
      reasonHint: 'Viene registrato con la richiesta, così la sospensione si può giustificare in seguito.',
      submit: 'Sospendi promemoria',
      errorUntil: 'Scegli il giorno in cui i promemoria riprendono.',
      errorRange: 'Scegli un giorno tra domani e la scadenza della risposta.',
      errorReason: 'Indica il motivo della sospensione.',
    },
    veto: {
      title: 'Aprire la finestra di veto?',
      body: 'Per le prossime 72 ore la cancellazione viene trattenuta: la richiesta non può essere chiusa come cancellata. Usa il tempo per verificare se serve un obbligo di conservazione o un rifiuto. La finestra non si può chiudere prima.',
      confirm: 'Apri finestra di veto',
    },
    holds: {
      title: 'Obblighi di conservazione',
      intro: 'Un obbligo di conservazione impedisce la cancellazione dei dati — tramite una richiesta, le regole di conservazione o l’eliminazione dello spazio di lavoro — finché non viene revocato. Ogni obbligo va confermato di nuovo ogni sei mesi.',
      placeTenant: 'Conserva tutto lo spazio di lavoro',
      empty: 'Nessun obbligo di conservazione attivo.',
      lapsedNotice: 'Obblighi con data di conferma superata: {count}. Bloccano ancora la cancellazione: confermali o revocali.',
      scopeTenant: 'Tutto lo spazio di lavoro',
      scopeSubject: 'Una persona',
      lapsed: 'Conferma scaduta',
      placedAt: 'Impostato il',
      attestationDue: 'Da confermare entro il',
      basis: 'Base giuridica',
      attest: 'Ancora necessario',
      attestConfirm: {
        title: 'Mantenere questo obbligo?',
        body: 'Confermi che il motivo dell’obbligo è ancora valido. Resta in vigore per altri sei mesi.',
        confirm: 'Mantieni obbligo',
      },
      release: {
        open: 'Revoca',
        title: 'Revoca l’obbligo di conservazione',
        warning: 'D’ora in poi i dati protetti da questo obbligo possono essere cancellati: da richieste aperte, dalle regole di conservazione o dall’eliminazione dello spazio di lavoro. Non si può annullare.',
        reasonLabel: 'Perché l’obbligo non serve più?',
        reasonHint: 'Viene registrato con il tuo nome.',
        submit: 'Revoca obbligo',
        errorReason: 'Indica il motivo della revoca.',
      },
      place: {
        titleTenant: 'Conserva tutto lo spazio di lavoro',
        titleSubject: 'Conserva per questa persona',
        bodyTenant: 'Finché l’obbligo è in vigore, nessun dato di questo spazio di lavoro può essere cancellato: né tramite richieste, né dalle regole di conservazione, né dall’eliminazione dello spazio di lavoro.',
        bodySubject: 'Finché l’obbligo è in vigore, nessun dato della persona indicata in questa richiesta può essere cancellato. La richiesta va comunque evasa nei termini.',
        reasonLabel: 'Motivo',
        reasonHint: 'Per esempio il procedimento giudiziario o la richiesta di un’autorità che impone di conservare i dati.',
        basisLabel: 'Base giuridica (facoltativa)',
        basisHint: 'Un breve riferimento, per esempio la norma o il numero di pratica.',
        submit: 'Imposta obbligo',
        errorReason: 'Indica il motivo dell’obbligo.',
      },
      errors: {
        notActive: 'Questo obbligo non è più attivo: è stato modificato nel frattempo. L’elenco è stato ricaricato.',
      },
    },
    restrictions: {
      title: 'Limitazioni del trattamento',
      intro: 'Un record limitato può essere conservato ma non utilizzato (art. 18 GDPR). Prima di revocare una limitazione, la persona deve esserne informata.',
      empty: 'Nessun trattamento è limitato.',
      originSystem: 'Impostata dopo una cancellazione',
      originRequest: 'Da una richiesta',
      notified: 'Persona informata il {date}',
      notNotified: 'Persona non ancora informata',
      placedAt: 'Limitato dal {date}',
      notifyOpen: 'Informa la persona',
      notifyAgain: 'Registra una nuova comunicazione',
      lift: 'Revoca limitazione',
      liftConfirm: {
        title: 'Revocare la limitazione?',
        body: 'Il record può di nuovo essere usato come prima. La persona è stata informata.',
        bodySystem: 'Questa limitazione è stata impostata automaticamente su ciò che è stato conservato dopo la cancellazione dei dati della persona. Revocarla rende questi record di nuovo modificabili e utilizzabili. Revocala solo se la limitazione non è più necessaria.',
        confirm: 'Revoca limitazione',
      },
      errors: {
        notActive: 'Questa limitazione non è più attiva, oppure la persona non è ancora stata informata. L’elenco è stato ricaricato.',
      },
      place: {
        title: 'Limita il trattamento',
        body: 'Il record della persona indicata in questa richiesta viene conservato ma non può più essere usato finché la limitazione non viene revocata. La limitazione è collegata a questa richiesta.',
        reasonLabel: 'Motivo',
        reasonHint: 'Per esempio: la persona contesta l’esattezza dei dati.',
        submit: 'Limita',
        errorReason: 'Indica il motivo della limitazione.',
      },
      notify: {
        title: 'Informa la persona',
        body: 'La persona deve essere informata prima che la limitazione venga revocata (art. 18, par. 3, GDPR).',
        modeLabel: 'Come viene informata la persona?',
        modeSend: 'lumi invia un’e-mail',
        modeManual: 'Già informata in altro modo',
        manualOnly: 'Questa limitazione non è collegata a nessuna richiesta, quindi lumi non ha un indirizzo. Informa tu la persona e registralo qui.',
        employerLabel: 'Datore di lavoro indicato nell’e-mail',
        employerHint: 'La persona deve poter capire chi ha limitato i suoi dati.',
        refLabel: 'Riferimento',
        refHint: 'Come l’hai informata, per esempio «lettera del 3 maggio» o un numero di pratica.',
        dateLabel: 'Informata il',
        dateHint: 'Lascia vuoto per oggi.',
        submitSend: 'Invia e-mail',
        submitManual: 'Registra comunicazione',
        sendRefused: 'Non è stato possibile inviare l’e-mail: la richiesta non contiene un indirizzo e-mail. Informa la persona in altro modo e registralo.',
        errorEmployer: 'Indica il datore di lavoro.',
        errorRef: 'Indica un riferimento per la comunicazione.',
      },
    },
    review: {
      title: 'Verifica la copia',
      intro: 'È così che la persona leggerà la sua copia. Decidi tu su ogni voce segnalata, una per una: rilasciarla o trattenerla (art. 15, par. 4, GDPR). Tutto il resto è in sola lettura.',
      back: 'Torna alle richieste',
      counter: {
        undecided: 'Restano da decidere {undecided} voci su {flagged}',
        allDecided: 'Tutte le {flagged} voci segnalate sono decise',
        noneFlagged: 'Nessuna voce è segnalata: puoi rilasciare subito la copia',
      },
      modules: {
        people: 'Personale',
        ats: 'Candidature',
        time: 'Tempo',
        apprentice: 'Apprendistato',
      },
      moduleState: {
        notInstalled: 'Questo modulo non fa parte di questo spazio di lavoro, quindi non vi è memorizzato nulla.',
        removed: 'Questo modulo è stato rimosso dallo spazio di lavoro; non resta nulla sulla persona.',
        unavailable: 'Questo modulo non era raggiungibile durante la preparazione della copia: quest’area manca nella copia. Porta la richiesta su «Attendi la persona» e poi di nuovo su «Inizia la lavorazione»: lumi prepara la copia da capo. Oppure rilasciala consapevolmente senza quest’area.',
      },
      moduleEmpty: 'Qui non è memorizzato nulla sulla persona.',
      delivered: 'Consegnata: lumi chiude la richiesta a breve',
      self: {
        title: 'Questa richiesta riguarda te',
        description: 'Un altro responsabile della protezione dei dati deve verificare la copia. Puoi rispondere alla richiesta a mano.',
      },
      unverified: 'lumi non è riuscito a verificare ora se questa richiesta riguarda te. Riprova tra un momento.',
      sectionMeta: 'Trattamento: {activity}',
      flagged: 'Segnalata',
      flagReason: {
        written: 'Scritta da un’altra persona sulla persona interessata, oppure nomina altre persone. Valuta se la persona può leggere questa voce.',
        generic: 'Può contenere informazioni su altre persone o provenire da altri. Valutala secondo l’art. 15, par. 4, GDPR.',
      },
      state: {
        undecided: 'Non ancora decisa',
        release: 'Sarà rilasciata',
        withhold: 'Sarà trattenuta',
      },
      decision: {
        group: 'Decisione su una voce di «{section}»',
        release: 'Rilascia',
        withhold: 'Trattieni',
        changeReason: 'Cambia il motivo',
        reasonLabel: 'Motivo per la persona',
        reasonHint: 'La persona leggerà questo motivo nella sua copia. Scrivilo per lei e non riportare il contenuto della voce.',
        reasonSave: 'Salva come trattenuta',
        reasonRequired: 'Indica un motivo.',
        saveError: 'Non è stato possibile salvare la decisione. La voce mantiene lo stato precedente.',
      },
      release: {
        action: 'Rilascia la copia',
        blocked: 'Decidi prima le {undecided} voci segnalate ancora aperte, poi potrai rilasciare la copia.',
        confirmTitle: 'Rilasciare la copia?',
        confirmBody: 'lumi crea ora la copia senza le voci trattenute ({withheld}), avvisa la persona e chiude la richiesta.',
        confirmBodyNone: 'lumi crea ora la copia, avvisa la persona e chiude la richiesta.',
        confirmLabel: 'Rilascia',
        done: 'Rilasciata: lumi consegna la copia',
      },
      errors: {
        undecided: 'Ci sono ancora voci segnalate aperte. La pagina è stata ricaricata.',
        expired: 'La copia è scaduta: lumi ne crea una nuova e la rivedrai qui a breve',
        closed: 'La richiesta non è più aperta. La copia non può più essere rilasciata.',
      },
      notFound: {
        title: 'Qui non c’è nessuna copia in attesa',
        description: 'La copia è scaduta o è già stata consegnata. Se la richiesta è ancora aperta, lumi ne crea una nuova e la rivedrai a breve nell’elenco.',
      },
    },
  },
  legalNotices: {
    title: 'Informativa privacy e IA per i dipendenti',
    intro: 'Cosa comunica questo workspace ai propri dipendenti su privacy e uso dell’IA sul lavoro.',
    titleLabel: 'Titolo',
    contentLabel: 'Testo dell’informativa',
    editMode: 'Modifica',
    previewMode: 'Anteprima',
    followingVersion: 'Segue la versione lumi {version}',
    branchedFromVersion: 'Testo proprio (derivato dalla versione {version} il {date})',
    updateAvailable: 'È disponibile una versione lumi più recente ({version}).',
    compareVersions: 'Confronta',
    hideComparison: 'Nascondi confronto',
    yourText: 'Il tuo testo',
    lumiVersionHeading: 'Versione lumi {version}',
    adoptVersion: 'Adotta versione {version}',
    adoptConfirm: 'Sostituire il tuo testo in entrambe le lingue con la versione {version} di lumi?',
    adopted: 'Versione di lumi adottata.',
    saved: 'Salvato.',
    noticeRequired: 'L’informativa non può essere salvata vuota.',
    lumiVersionUnavailable: 'Non è stato possibile raggiungere la versione attuale di lumi — riprova a breve.',
    forbidden: 'Non hai accesso a questa informativa.',
    supportRefused: 'Una sessione di supporto non copre questa informativa.',
    membershipUnavailable: 'Non è stato possibile verificare il tuo accesso ora — riprova a breve.',
    loadFailed: 'Impossibile caricare l’informativa.',
    compareUnavailable: 'lumi non è raggiungibile, quindi il confronto e Adotta non sono disponibili ora.',
    blanksOpenRefusal: 'Il testo contiene ancora campi da completare: {list}. Completali qui sopra, oppure sostituiscili con un tuo testo, prima di salvare.',
    unsavedWarning: 'Non hai ancora salvato le modifiche a {name}.',
    demoDisclaimer: 'QUESTA È LA VERSIONE DEMO DI UN’AZIENDA DEMO FITTIZIA. NON È UN DOCUMENTO LEGALMENTE VINCOLANTE.',
    blanks: {
      lead: 'I modelli di lumi hanno bisogno di questi dati da parte tua. Inserisci ciascuno una sola volta: viene inserito in tutti i testi qui sotto, in entrambe le lingue.',
      saved: 'Salvato.',
      complete: 'Tutte le informazioni richieste sono state fornite.',
      suggested: 'Presa dal profilo dell’azienda: controllala, poi salva.',
      keys: {
        company_name: { label: 'Nome dell’azienda', hint: 'La ragione sociale di questo workspace, così come deve comparire nell’informativa.' },
        company_address: { label: 'Indirizzo dell’azienda', hint: 'L’indirizzo postale a cui dipendenti e candidati possono contattarti.' },
        privacy_contact: { label: 'Contatto per la protezione dei dati', hint: 'A chi rivolgersi per la protezione dei dati — un nome, un ruolo o un indirizzo e-mail.' },
        applicant_retention: { label: 'Periodo di conservazione dei dati dei candidati', hint: 'Per quanto tempo le candidature non selezionate vengono conservate prima della cancellazione.' },
      },
    },
    // The page's two-step checklist (issue 766): the facts form, then the imprint.
    checklist: {
      title: 'Per completare i tuoi testi legali',
      progress: '{done} di {total} completati',
      facts: { title: 'Dati per tutti i testi', hint: 'Ragione sociale, indirizzo, contatto per la protezione dei dati e altro: inseriti in ogni testo qui sotto.' },
      imprintAction: 'Inserisci le note legali',
    },
    candidate: {
      heading: 'Informative per i candidati',
      intro: 'Le informative legali che questo spazio di lavoro mostra alle persone candidate sul portale carriere.',
      unavailable: 'Le informative per i candidati non sono disponibili in questo momento.',
      noticeRequired: 'Questa informativa è mostrata alle persone candidate e non può restare vuota. Sostituisci il testo oppure adotta la versione di lumi.',
      imprintRequired: 'Le note legali non possono essere svuotate mentre il portale è online. Sostituisci il testo invece di cancellarlo.',
      privacy: {
        title: 'Informativa sulla privacy del tenant',
        subtitle: 'Questa versione viene mostrata sul portale ai candidati.',
      },
      aiUsage: {
        title: 'Informativa sull\'uso dell\'IA per i candidati',
        subtitle: 'Questo testo viene mostrato ai candidati sul portale carriere.',
      },
      imprint: {
        title: 'Note legali del portale carriere',
        subtitle: 'Questo testo è collegato da ogni pagina del portale.',
        hint: 'Le note legali sono obbligatorie per legge (§ 5 DDG). Il portale carriere resta offline finché non ne è salvata una, in qualsiasi lingua.',
        fallsBack: 'Le tue note legali sono salvate. Le lingue senza note legali proprie mostrano sul portale la versione {language}.',
      },
      history: {
        title: 'Che cosa mostravamo in una certa data?',
        hint: 'Cerca il testo esatto presente su questa pagina in un momento passato, per la domanda di una persona candidata o di un\'autorità.',
        open: 'Cerca',
        hide: 'Chiudi',
        dateLabel: 'Data e ora',
        localeLabel: 'Lingua',
        lookUp: 'Mostra il testo',
        periodClosed: 'Pubblicato dal {from} al {until}.',
        periodOpen: 'Pubblicato dal {from}: è ancora il testo attuale.',
        sourceLumi: 'La versione {version} pubblicata da lumi, parola per parola.',
        sourceLumiUnversioned: 'Il testo pubblicato da lumi.',
        sourceTenant: 'Il testo proprio di questo spazio di lavoro, derivato dalla versione lumi {version}.',
        sourceTenantOwn: 'Il testo proprio di questo spazio di lavoro.',
        none: 'La registrazione non risale così indietro.',
        provenanceFollowing: 'Ciò che risulta: questa pagina è una copia della versione lumi {version} e qui nessuno l’ha riscritta.',
        provenanceBranched: 'Ciò che risulta: questa pagina proviene dalla versione lumi {version} ed è stata riscritta il {date}.',
        provenanceUnknown: 'Per il periodo precedente non risulta altro su questa pagina.',
        futureRefused: 'Questa registrazione dice che cosa una pagina ha mostrato, non che cosa mostrerà. Scegli un momento già passato.',
        invalidRefused: 'Scegli una data e una lingua per la ricerca.',
        failed: 'Non è stato possibile leggere la registrazione in questo momento. Riprova.',
      },
    },
  },
  legalNoticePublic: {
    unavailable: 'Questa informativa non è disponibile al momento.',
  },
  dataImportHub: {
    nav: 'Import dati',
    title: 'Import ed export dati',
    intro: 'Importa ed esporta i dati esistenti nei moduli da un unico punto. Ogni azione viene eseguita nel modulo di destinazione con i tuoi permessi.',
    locked: 'Nessun permesso in questo modulo',
    lockedDetail: 'Ti manca il permesso di import (data_import.manage) in {module}. Chiedi a un admin del modulo.',
    plan: {
      title: 'Piano di import',
      run: 'Crea ora i valori mancanti',
      summary: 'Mancano {count} valori in {module}; possono essere creati lì come import.',
      truncated: 'Elenco troncato — vengono rilevati fino a 200 valori mancanti per campo.',
      forbidden: 'Ti manca il permesso in {module}.',
      running: 'Import companion in corso…',
      waiting: 'In attesa che i nuovi valori raggiungano il modulo di destinazione…',
      rerunning: 'Nuova esecuzione della prova nel modulo di destinazione…',
      done: 'Fatto — la prova usa i nuovi valori.',
      failed: 'L’import companion non è riuscito.',
      confirmTitle: 'Creare i valori mancanti?',
      confirmBody: 'Mancano {count} valori in {module}. Crearli ora tramite import? La prova si riavvia automaticamente dopo.',
      companionErrors: 'La prova companion segnala errori — verifica nel modulo.',
      projectionTimeout: 'La proiezione nel modulo di destinazione richiede più tempo del previsto — riprova più tardi.',
    },
    createField: {
      title: 'Crea un nuovo campo personalizzato',
      intro: 'Crea un campo personalizzato per la colonna “{column}”. Sarà poi disponibile in tutto l’ATS.',
      typeHint: 'I campi a scelta (select/selezione multipla) si creano nella gestione dei campi.',
      sensitiveNotImportable: 'I campi di categorie particolari (art. 9) vengono creati ma volutamente non sono una destinazione di importazione.',
      submit: 'Crea campo',
      label: 'Etichetta',
      keyLabel: 'Chiave del campo (Key)',
      keyHint: 'Solo lettere minuscole, numeri e trattini bassi',
      typeLabel: 'Tipo',
      types: {
        text: 'Testo',
        textarea: 'Area di testo',
        number: 'Numero',
        date: 'Data',
        checkbox: 'Casella di controllo',
      },
      sensitivityLabel: 'Che tipo di dati contiene questo campo?',
      sensitivityUnanswered: 'Scegli un’opzione',
      sensitivityNone: 'Nessuna categoria particolare',
      sensitivityHint: 'I dati particolari (art. 9 GDPR) non possono determinare decisioni automatizzate su una candidatura.',
      sensitivityCategories: {
        racialEthnic: 'Origine razziale o etnica',
        politicalOpinion: 'Opinioni politiche',
        religiousPhilosophical: 'Convinzioni religiose o filosofiche',
        tradeUnion: 'Appartenenza sindacale',
        genetic: 'Dati genetici',
        biometricId: 'Identificazione biometrica',
        health: 'Dati sulla salute',
        sexLifeOrientation: 'Vita sessuale o orientamento sessuale',
      },
      sensitivityRequired: 'Indica che tipo di dati contiene questo campo.',
    },
    entities: {
      person: 'Dipendenti',
      orgUnit: 'Unità org.',
      employmentContract: 'Contratti',
      job: 'Posizioni',
      candidate: 'Candidati',
      application: 'Candidature',
      client: 'Clienti',
      project: 'Progetti',
      timeEntry: 'Registrazioni',
      leaveRequest: 'Assenze',
    },
    // People's enum values in the words People uses for them (people-ui's own
    // labels): the import wizard names allowed values with these.
    peopleValues: {
      contractType: {
        permanent: 'a tempo indeterminato',
        fixed_term: 'a tempo determinato',
        mini_job: 'mini-job',
        midi_job: 'midi-job (fascia di transizione)',
        working_student: 'studente lavoratore',
        apprenticeship: 'apprendistato',
        internship: 'tirocinio',
        freelance: 'collaborazione / a parcella',
        managing_director: 'amministratore delegato / membro del consiglio',
        other: 'altro',
      },
      workTimeArrangement: {
        full_time: 'tempo pieno',
        part_time: 'tempo parziale',
        marginal: 'marginale (mini-job)',
        variable: 'variabile / flessibile',
      },
      status: {
        draft: 'Bozza',
        active: 'Attivo',
        on_hold: 'In pausa',
        terminated: 'Cessato',
        inactive: 'Inattivo',
      },
      type: {
        department: 'Reparto',
        location: 'Sede',
        team: 'Team',
        cost_center: 'Centro di costo',
      },
    },
    // People's import fields in People's own words (people-ui's labels), per
    // entity: the wizard's row errors name a field with these, never by its key.
    peopleFields: {
      orgUnit: {
        externalId: 'ID esterno',
        type: 'Tipo',
        name: 'Nome',
        code: 'Codice',
        description: 'Descrizione',
        parentExternalId: 'Unità superiore',
        parentCode: 'Unità superiore (Codice)',
        addressLine1: 'Indirizzo',
        postalCode: 'CAP',
        city: 'Città',
        country: 'Paese',
        active: 'Attivo',
      },
      person: {
        externalId: 'ID esterno',
        employeeNumber: 'Matricola',
        firstName: 'Nome',
        lastName: 'Cognome',
        salutation: 'Titolo',
        gender: 'Genere',
        email: 'E-mail',
        phone: 'Telefono',
        birthDate: 'Data di nascita',
        nationality: 'Nazionalità',
        maritalStatus: 'Stato civile',
        addressLine1: 'Indirizzo',
        addressLine2: 'Informazioni aggiuntive indirizzo',
        postalCode: 'CAP',
        city: 'Città',
        country: 'Paese',
        workCountry: 'Luogo di lavoro (paese)',
        primaryLocale: 'Lingua',
        status: 'Stato',
        primaryOrgUnitExternalId: 'Reparto / unità',
        primaryOrgUnitCode: 'Reparto / unità (Codice)',
        supervisorExternalId: 'Responsabile funzionale',
      },
      employmentContract: {
        externalId: 'ID esterno',
        personExternalId: 'Persona',
        contractReference: 'Numero contratto',
        status: 'Stato del contratto',
        startDate: 'Data di inizio',
        endDate: 'Data di fine',
        probationEndDate: 'Fine periodo di prova',
        contractType: 'Tipo di contratto',
        position: 'Posizione / mansione',
        primaryOrgUnitExternalId: 'Reparto / unità',
        supervisorExternalId: 'Responsabile gerarchico',
        workTimeArrangement: 'Orario di lavoro',
        weeklyHours: 'Ore settimanali',
        vacationDaysPerYear: 'Ferie (giorni/anno)',
        collectiveAgreementCode: 'Contratto collettivo',
      },
    },
  },
  // ── Tenant administration (#432): the five pages that used to be their own
  //     app. Merged verbatim from its catalogue, so the strings are unchanged.
  audit: {
    title: 'Audit Log', subtitle: 'Who did what in your workspace.',
    noAccess: 'No access', noAccessHint: 'You need the audit log permission to view this page.',
    empty: 'No audit events yet', emptyHint: 'Actions in your workspace will appear here.',
    loading: 'Loading…', loadMore: 'Load more',
    filters: { from: 'From', to: 'To', action: 'Action', category: 'Category', actor: 'Actor', outcome: 'Outcome', search: 'Search', searchHint: 'Subject or actor…', apply: 'Apply', reset: 'Reset', all: 'All', actorType: 'Tipo di attore' },
    columns: { time: 'Time', actor: 'Actor', action: 'Action', subject: 'Subject', outcome: 'Outcome' },
    outcome: { success: 'Success', denied: 'Denied', failure: 'Failure' },
    actorType: { user: 'User', system_admin: 'System Admin', support: 'Support', service: 'Service', system: 'System' },
    categories: { auth: 'Auth', access: 'Access', data: 'Data', admin: 'Admin', lifecycle: 'Lifecycle', export: 'Export', security: 'Security' },
    export: { csv: 'Export CSV', ndjson: 'Export NDJSON' },
    detail: { roles: 'Ruoli', action: 'Action', actorId: 'Actor ID', onBehalfOf: 'On behalf of', ip: 'IP address', source: 'Source', correlationId: 'Correlation ID', changes: 'Changes', before: 'Before', after: 'After', details: 'Details' },
    actions: { login: { succeeded: 'Login succeeded', failed: 'Login failed', attempts_flagged: 'Tentativi di accesso non riusciti ripetuti', locked: 'Account bloccato' }, sso: { login_succeeded: 'SSO login succeeded', connection_changed: 'SSO connection changed' }, password: { reset_requested: 'Password reset requested', reset_completed: 'Password reset completed' }, refresh_token: { revoked: 'Session revoked' }, user: { signed_up: 'User signed up', unlocked: 'Account sbloccato', disabled: 'Account disattivato', enabled: 'Account attivato', closed: 'Account chiuso' }, passkey: { revoked: 'Passkey rimosse da un amministratore' }, role: { changed: 'Role changed' }, module_access: { changed: 'Module access changed' }, access: { ownership_transferred: 'Proprietà trasferita', member_removed: 'Membro rimosso', suite_roles_changed: 'Ruoli Suite modificati' }, tenant: { created: 'Tenant creato', lifecycle: 'Tenant lifecycle change', exported: 'Tenant esportato' }, module: { activated: 'Module activated', deactivated: 'Module deactivated' }, plan: { changed: 'Plan changed' }, tenant_ai_settings: { changed: 'Impostazioni IA modificate' }, tenant_role_editing: { changed: 'Modifica dei ruoli cambiata' }, settings: { changed: 'Settings changed' }, test_data: { seeded: 'Test data seeded', reset: 'Test data reset' }, onboarding: { setup_chosen: 'Configurazione scelta', demo_started: 'Modalità demo avviata', demo_seeded: 'Dati demo creati', demo_seed_failed: 'Creazione dei dati demo non riuscita', demo_wipe_started: 'Eliminazione della demo avviata', demo_wiped: 'Dati demo eliminati', demo_wipe_failed: 'Eliminazione dei dati demo non riuscita', setup_finished: 'Configurazione completata', demo_denied: 'Modalità demo negata', module_topup: 'Dati demo aggiunti per il nuovo modulo', demo_reset_started: 'Ripristino della demo avviato', demo_tier_switch_started: 'Passaggio alla demo completa avviato', demo_rebuilt: 'Demo ricostruita' }, company_profile: { created: 'Profilo aziendale creato', updated: 'Profilo aziendale aggiornato' }, org_scenario: { activated: 'Scenario organizzativo attivato' }, people_data: { wiped: 'Dati del personale eliminati' }, ats_data: { wiped: 'Dati di selezione eliminati' }, time_data: { wiped: 'Dati di rilevazione presenze eliminati' }, apprentice_data: { wiped: 'Dati di formazione eliminati' }, audit_log: { exported: 'Audit log exported' }, billing_charge: { paid: 'Pagamento addebitato', failed: 'Pagamento fallito', refunded: 'Pagamento rimborsato', chargeback: 'Storno ricevuto' }, invoice: { issued: 'Fattura emessa' }, mandate: { created: 'Carta aggiunta', replaced: 'Carta sostituita' }, promo_code: { redeemed: 'Codice promozionale riscattato' }, billing_account: { converted: 'Prova convertita in abbonamento', delinquent: 'Account moroso', purged: 'Dati di fatturazione eliminati' }, dunning_case: { opened: 'Recupero crediti avviato' }, enforcement: { opened: 'Applicazione avviata', advanced: 'Applicazione inasprita', cleared: 'Applicazione revocata' }, billing_exempt: { changed: 'Esenzione dalla fatturazione modificata' }, billing_data: { wiped: 'Dati di fatturazione cancellati', generated: 'Dati di fatturazione di test generati' }, checkout: { completed: 'Acquisto completato', denied: 'Acquisto rifiutato' }, job: { created: 'Posizione creata', updated: 'Posizione aggiornata', submitted: 'Posizione inviata', archived: 'Posizione archiviata', deleted: 'Posizione eliminata' }, application: { created: 'Candidatura ricevuta', updated: 'Candidatura aggiornata', transitioned: 'Stato della candidatura modificato', withdrawn: 'Candidatura ritirata', transferred: 'Candidatura trasferita a un’altra posizione', transfer_declined: 'Trasferimento della candidatura rifiutato', rejected: 'Candidatura rifiutata', deleted: 'Candidatura eliminata', emailed: 'E-mail di candidatura inviata' }, interview: { proposed: 'Colloquio proposto', confirmed: 'Colloquio confermato', cancelled: 'Colloquio annullato' }, candidate: { anonymized: 'Candidato anonimizzato', emailed: 'E-mail al candidato inviata', identity_changed: 'Dati del candidato modificati', identity_split: 'Candidato separato su una scheda propria', identity_merged: 'Candidatura spostata al candidato con questo indirizzo' }, candidate_dossier: { accessed: 'Il candidato ha consultato i propri dati' }, workflow: { deleted: 'Workflow eliminato', definition: { published: 'Workflow pubblicato' } }, task: { blocking_overridden: 'Attività bloccante ignorata', auto_cancelled: 'Attività annullata automaticamente' }, support_access: { requested: 'Accesso del supporto richiesto', approved: 'Accesso del supporto approvato', denied: 'Accesso del supporto rifiutato', revoked: 'Accesso del supporto terminato', expired: 'Accesso del supporto scaduto', request_expired: 'Richiesta di accesso del supporto scaduta' }, ai_action: { executed: 'Azione IA eseguita' }, assistant_run: { proposed: 'lumi ha proposto un\'azione', approved: 'Azione lumi approvata', refused: 'Azione lumi rifiutata', failed: 'Azione lumi non riuscita' }, assistant_turn: { fanned_out: 'Richiesta lumi estesa a più moduli' }, payroll_export_run: { created: 'Esportazione paghe avviata', completed: 'Esportazione paghe completata', failed: 'Esportazione paghe non riuscita', downloaded: 'Esportazione paghe scaricata' }, payroll_period: { closed: 'Mese paghe chiuso', reopened: 'Mese paghe riaperto' }, payroll_connection: { updated: 'Collegamento paghe modificato' }, payroll_master_data: { exported: 'Dati anagrafici paghe esportati' }, wage_type: { created: 'Voce retributiva creata', updated: 'Voce retributiva aggiornata', deleted: 'Voce retributiva eliminata', starter_catalog_applied: 'Voci retributive standard aggiunte' }, wage_assignment: { created: 'Componente retributiva aggiunta', updated: 'Componente retributiva modificata', deleted: 'Componente retributiva rimossa' }, one_time_payment: { created: 'Pagamento una tantum aggiunto', updated: 'Pagamento una tantum modificato', deleted: 'Pagamento una tantum rimosso' }, payslip: { filed: 'Buste paga archiviate' } },
  },
  sso: {
    title: 'Single Sign-On',
    subtitle: 'Collega il tuo provider di identità (OIDC) in modo che il tuo team acceda tramite esso.',
    issuerUrl: 'URL dell’emittente (discovery OIDC)',
    clientId: 'Client ID',
    clientSecret: 'Client secret',
    clientSecretKeep: 'Lascia vuoto per mantenere il secret salvato',
    label: 'Nome visualizzato',
    allowedDomains: 'Domini e-mail consentiti (separati da virgole)',
    jitEnabled: 'Crea automaticamente gli utenti al primo accesso (JIT)',
    jitDefaults: 'Accesso ai moduli predefinito per i nuovi utenti',
    jitModulePlaceholder: 'Scegli un modulo',
    jitRoles: 'Ruoli',
    jitCatalogUnreadable: 'Non è stato possibile leggere i ruoli di questo modulo. I ruoli salvati restano invariati.',
    jitUnknownRole: '{key} (sconosciuto)',
    addJit: 'Aggiungi modulo',
    remove: 'Remove',
    redirectUri: 'URI di reindirizzamento (registralo nel tuo IdP)',
    copy: 'Copia',
    test: 'Prova connessione',
    testOk: 'Discovery riuscita.',
    testFailed: 'Prova non riuscita',
    save: 'Salva',
    saved: 'Salvato.',
    delete: 'Rimuovi connessione',
    deleteConfirm: 'Rimuovere davvero questa connessione SSO?',
    enforce: 'Richiedi l’accesso solo tramite SSO',
    enforceHint: 'L’accesso con password è disattivato per tutti tranne gli amministratori di sistema e il proprietario del workspace.',
    noConnection: 'Nessuna connessione SSO ancora configurata.',
    deleted: 'Connessione rimossa.',
    enforceEnabled: 'Ora l’accesso è possibile solo tramite SSO.',
    enforceDisabled: 'L’accesso con password è di nuovo disponibile.',
    jitNeedsVerifiedDomain: 'Gli utenti vengono creati automaticamente solo per indirizzi di un dominio verificato.',
    domainsTitle: 'Domini e-mail',
    domainsIntro: 'Un dominio conta per l’accesso SSO solo dopo che hai dimostrato che è vostro: pubblica questo record TXT nel DNS del dominio, poi verificalo. Nel frattempo gli account già collegati continuano ad accedere.',
    domainStatus: { pending: 'Non verificato', verified: 'Verificato', legacy: 'Da verificare presto' },
    domainLegacyUntil: 'Da verificare entro il {date}',
    domainRecordName: 'Nome del record (TXT)',
    domainRecordValue: 'Valore del record',
    domainVerify: 'Controlla record',
    domainVerified: '{domain} è verificato.',
    domainError: { record_not_found: 'Non esiste ancora un record TXT con questo nome. Le modifiche DNS possono richiedere un po’ di tempo.', value_mismatch: 'Esiste un record TXT, ma il suo valore non corrisponde. Copia il valore esattamente.', dns_error: 'La ricerca DNS non è riuscita. Riprova tra qualche minuto.' },
  },  users: { seatLimit: { bookMore: 'Tutte le {booked} postazioni utente prenotate sono occupate. Prenota almeno {required} postazioni utente per invitare qualcun altro.', leaveFreelancer: 'Questo workspace è in modalità freelance: una persona, una postazione. Uscendo dalla modalità freelance prenoti {required} postazioni utente e fai spazio alle persone che inviti.', notified: 'Tutte le {booked} postazioni utente prenotate sono occupate. Il proprietario del workspace e i Billing Manager possono prenotare altre postazioni.', cta: 'Prenota altre postazioni' }, removeSuccess: '{email} è stato rimosso da questo workspace.', saveSuccess: 'Modifiche di accesso salvate per {email}.', saveFailedFor: 'Impossibile salvare {targets} per {email}: {reason}', saveFailedOthersSaved: 'Le altre modifiche sono state salvate.', suiteRolesTarget: 'i ruoli suite', unsaved: 'Non salvato', defaultRoleHint: 'Ruolo predefinito per gli inviti interni', refreshFailed: 'Impossibile aggiornare l’elenco dei membri. Ricarica la pagina per vedere lo stato salvato.', title: 'Utenti & Assegnazioni', email: 'E-mail', suite: 'Suite', suiteSuiteAdmin: 'Admin', suiteSuiteAdminHint: 'Admin del workspace: gestisce membri, accesso ai moduli, SSO e sicurezza.', suiteBillingManager: 'Billing Manager', suiteBillingManagerHint: 'Può gestire la fatturazione (fatture, carta, piano).', suiteSupportAgent: 'Support Agent', suiteSupportAgentHint: 'Gestisce i ticket di supporto (rispondere, escalation, chiusura).', suiteDataProtection: 'Responsabile della protezione dei dati', suiteDataProtectionHint: 'Esamina e approva le richieste degli interessati e le cancellazioni e può consultare i dati dei membri in ogni modulo attivo.', suiteOwnerLocked: 'Il proprietario del workspace è sempre Admin.', saveFailed: 'Impossibile salvare l\'assegnazione', inviteSuccess: '{email} è stato invitato con successo', invite: { titleInternal: 'Invita un membro', titleExternal: 'Invita esternamente', hintInternal: 'Riceve automaticamente il ruolo predefinito in Tempo e Personale — puoi aggiungere altri ruoli subito dopo l’invito.', hintExternal: 'Nessun ruolo predefinito: senza un ruolo questa persona non può aprire alcun modulo. Configura l’accesso subito dopo l’invito.', submit: 'Invita', sentTitle: 'Invito inviato', sentLead: '{email} è stato invitato e risulta come Invitato.', sentBodyInternal: 'Ha già il ruolo predefinito in Tempo e Personale.', sentBodyExternal: 'Ancora senza ruoli — configura a cosa questa persona può accedere.', revoke: 'Ritira invito', moreRoles: 'Altri ruoli', setupRoles: 'Configura ruoli', done: 'Fatto', revokedTitle: 'Invito ritirato', revokedBody: '{email} è stato rimosso dal workspace. Il link di invito non è più valido.' }, removeUser: 'Rimuovi', confirmRemove: 'Sei sicuro di voler rimuovere {email} da questo tenant? Tutte le assegnazioni dei moduli verranno eliminate.', statusActive: 'Attivo', statusInvited: 'Invitato', statusDisabled: 'Disattivato', transferOwnership: 'Trasferisci la proprietà', transferTitle: 'Trasferisci la proprietà del workspace', transferIntro: '{from} consegna questo workspace a {to}. Il proprietario è uno solo: appena confermi, {from} non lo è più.', transferConsequences: 'Ecco cosa cambia:', transferConsequenceBreakGlass: 'L’accesso di emergenza in caso di SSO non disponibile passa a {to}: se il vostro identity provider non risponde, {to} può ancora accedere con la password, {from} no.', transferConsequenceOutgoing: '{from} conserva tutti i ruoli che ha già, incluso Admin — cambia solo la proprietà. Può essere disattivato o rimosso come qualsiasi altro membro.', transferConsequenceSuiteAdmin: '{to} riceve il ruolo Admin se non ce l’ha già. Nessuno perde un ruolo.', transferSsoWarning: '{email} accede tramite SSO e non ha una password. Se l’SSO non è disponibile non potrà usare l’accesso di emergenza che eredita: può impostare una password in qualsiasi momento con «Password dimenticata».', transferBlockedPending: '{email} non ha ancora accettato l’invito. Deve farlo prima di poter diventare proprietario.', transferBlockedDisabled: 'L’account di {email} è disattivato. Riattivalo prima di trasferire la proprietà.', transferConfirmFieldLabel: 'Conferma il nuovo proprietario', transferConfirmHint: 'Digita {email} per abilitare il pulsante.', transferSuccess: '{email} è ora il proprietario di questo workspace.', transferFailed: 'Non è stato possibile trasferire la proprietà. Riprova.', transferErrorForbidden: 'Solo il proprietario attuale può trasferire la proprietà.', transferErrorNotMember: '{email} non è più un membro di questo workspace.', transferErrorAlreadyOwner: '{email} è già il proprietario di questo workspace.', transferErrorRaced: 'La proprietà è cambiata mentre questo trasferimento era in corso. Ricarica l’elenco e riprova.', transferErrorIneligible: '{email} non può assumere la proprietà in questo momento. Aggiorna l’elenco per vedere lo stato attuale.', resendInvite: 'Invia di nuovo l\'invito', disable: 'Disattiva', enable: 'Attiva', confirmDisable: 'Disattivare {email}? La persona verrà disconnessa immediatamente e non potrà accedere finché non riattivi l\'account.', resendSuccess: 'Invito inviato di nuovo a {email}.', resendEmailFailed: 'Impossibile inviare l\'e-mail di invito a {email}. Riprova.', disableSuccess: '{email} è stato disattivato.', enableSuccess: '{email} è stato attivato.', inviteEmailFailed: '{email} è stato aggiunto, ma non è stato possibile inviare l\'e-mail di invito. Puoi inviarla di nuovo.', searchPlaceholder: 'Cerca per e-mail', rolesFilterPlaceholder: 'Filtra per ruolo', clearRolesFilter: 'Reimposta filtro', memberCount: '{count} membri', memberCountFiltered: '{shown} di {count} membri', inviteInternal: 'Invita', inviteExternal: 'Invita esternamente', removeRoleFilter: 'Rimuovi ruolo dal filtro', columns: { account: 'Account', status: 'Stato', roles: 'Ruoli' },moduleNames: { ats: 'Recruiting', time_tracking: 'Tempo', people: 'Personale', apprenticeship: 'Ausbildung' }, accessDenied: 'Accesso negato', moreActions: 'Altre azioni per {email}', noSearchResults: 'Nessun membro corrisponde a «{query}».', editSubtitle: 'Modifica ruoli e accesso', suiteConfirmGrantTitle: 'Assegnare un ruolo suite?', suiteConfirmRevokeTitle: 'Revocare un ruolo suite?', suiteConfirmMixedTitle: 'Modificare i ruoli suite?', suiteConfirmLead: 'Questo cambia per {email}:', suiteConfirmRemoved: 'Perde {role}.', suiteConfirmAccept: 'Sì, salva' },
  // The consent page of an agent connection (ADR 0103 rule 10, PDR 0035).
  connectAgent: {
    title: 'Collega un agente IA',
    heading: 'Un agente IA vuole agire per tuo conto',
    intro: 'Un client IA che si presenta come «{client}» chiede di lavorare in lumi per tuo conto, nel workspace {workspace}.',
    fields: {
      client: 'Si presenta come',
      redirectHost: 'Ti rimanda a',
      website: 'Sito web indicato',
      workspace: 'Nel workspace',
    },
    scopesHeading: 'Chiede di:',
    scope: {
      read: 'Leggere ciò che puoi vedere in lumi',
      act: 'Proporre ed eseguire azioni per tuo conto — ogni azione richiede la tua conferma',
      ask: 'Fare domande a lumi',
    },
    meaning: {
      heading: 'Cosa significa «Consenti»',
      asYou: 'Agisce come te, esattamente con i tuoi permessi in questo workspace — mai di più.',
      egress: 'Tutto ciò che legge in lumi va al fornitore dietro «{client}», al di fuori di lumi.',
      revocable: 'Puoi terminare il collegamento in qualsiasi momento dalla pagina del tuo account.',
    },
    standing: {
      label: 'Esegui le azioni sui miei dati senza chiedere ogni volta',
      hint: 'Non vale mai per i dati di altre persone né per decisioni sfavorevoli: in quei casi la domanda arriva sempre. Puoi cambiarlo in qualsiasi momento dalla pagina del tuo account.',
    },
    rolePins: {
      title: 'Ruolo per modulo',
      hint: 'Dove hai più di un ruolo, scegli quello in cui lavora l’agente. Non può mai fare più di quanto quel ruolo consente.',
      default: 'Predefinito del modulo ({rule})',
      defaultRule: {
        first_assigned: 'il tuo primo ruolo assegnato',
        first_by_key: 'il tuo primo ruolo per chiave',
        all_roles: 'tutti i tuoi ruoli insieme',
      },
      modules: {
        ats: 'Recruiting',
        time: 'Tempo',
        people: 'Personale',
      },
      notHeld: 'Non hai più il ruolo scelto in quel modulo. Scegli di nuovo.',
    },
    disabled: {
      title: 'Gli agenti IA esterni sono disattivati in questo workspace',
      body: 'Un proprietario o un amministratore può attivarli in Amministrazione → Agenti IA esterni. Fino ad allora puoi solo rifiutare questa richiesta.',
    },
    actions: {
      allow: 'Consenti',
      deny: 'Rifiuta',
    },
    returning: 'Ritorno a {client}…',
    invalid: {
      title: 'Questa richiesta di accesso non è più valida',
      hint: 'Avvia di nuovo il collegamento dal tuo client IA.',
    },
  },
  // Administration › External AI agents (ADR 0103 rule 12, PDR 0035 rule 2).
  externalAgents: {
    title: 'Agenti IA esterni',
    cardTitle: 'Agenti IA esterni',
    noAccess: 'Nessun accesso',
    noAccessHint: 'Solo il proprietario del workspace e gli amministratori della suite possono modificare questa impostazione.',
    intro: 'Con questa opzione attiva, i membri possono collegare il proprio client IA — Claude Code, OpenClaw, … — e lasciarlo agire per loro conto in questo workspace.',
    points: {
      asMember: 'Un agente lavora esattamente con i permessi del membro che lo ha collegato — mai di più.',
      confirmed: 'Ogni azione che propone viene confermata da quel membro prima di essere eseguita.',
      adverse: 'Le decisioni sfavorevoli su altre persone richiedono sempre il pannello di lumi; un agente non può mai confermarle.',
    },
    egress: {
      title: 'Dove vanno i dati dei membri',
      body: 'Tutto ciò che un agente legge va al client IA collegato dal membro — un destinatario al di fuori della catena dei responsabili del trattamento di lumi, scelto dal tuo workspace e dal membro.',
      worksCouncil: 'Se i membri possano usare questi client è una tua decisione come datore di lavoro — valuta di coinvolgere le rappresentanze dei lavoratori.',
    },
    switchLabel: 'Consenti ai membri di collegare agenti IA esterni',
    saving: 'Salvataggio…',
    activeConnections: 'Nessun collegamento attivo. | 1 collegamento attivo. | {n} collegamenti attivi.',
    offHint: 'Disattivando, ogni collegamento in questo workspace termina subito.',
    roleNote: 'Solo il proprietario del workspace o un amministratore della suite può modificarlo.',
    savedOn: 'Gli agenti IA esterni sono attivi. Ora i membri possono collegare il proprio client IA.',
    savedOff: 'Gli agenti IA esterni sono disattivati. | Gli agenti IA esterni sono disattivati. È terminato 1 collegamento. | Gli agenti IA esterni sono disattivati. Sono terminati {n} collegamenti.',
    disableConfirm: {
      title: 'Disattivare gli agenti IA esterni?',
      body: 'Al momento nessun collegamento è attivo; i membri non potranno più collegarsi. | Questo termina subito 1 collegamento. | Questo termina subito {n} collegamenti.',
      confirm: 'Disattiva',
    },
  },
  supportAccess: {
    revokeConfirm: 'L’accesso del supporto termina subito. Il team di supporto perde l’accesso a questo workspace.',
    title: 'Accesso del supporto',
    subtitle: 'Accesso temporaneo al tuo spazio per il nostro team di supporto, autorizzato da te.',
    noAccess: 'Nessun accesso',
    noAccessHint: 'Solo il proprietario dello spazio e gli amministratori della suite possono esaminare queste richieste.',
    empty: 'Nessun accesso del supporto richiesto',
    emptyHint: 'Quando il nostro supporto avrà bisogno di accedere al tuo spazio per un ticket, la richiesta comparirà qui.',
    pendingTitle: 'Richiesta di accesso in attesa',
    pendingIntro: '{supporter} chiede {days} giorni di accesso a questo spazio.',
    activeTitle: 'L’accesso del supporto è attivo',
    activeIntro: '{supporter} può attualmente lavorare in questo spazio.',
    historyTitle: 'Cronologia',
    revokeHint: 'La chiusura ha effetto entro un minuto.',
    expiringNow: 'In scadenza ora',
    remainingDays: 'restano {days} g {hours} h',
    remainingHours: 'restano {hours} h {minutes} min',
    remainingMinutes: 'restano {minutes} min',
    fields: {
      requestedAt: 'Richiesto',
      ticket: 'Ticket di supporto',
      duration: 'Durata',
      durationValue: '{days} giorni',
      reason: 'Motivo indicato',
      approvedBy: 'Approvato da',
      expiresAt: 'Scade',
      remaining: 'Tempo rimanente',
      grantedModules: 'Ruoli concessi',
    },
    consent: { allRoles: 'La persona del supporto può passare a ogni ruolo offerto da questi moduli: vede ciò che vedono i tuoi collaboratori, non solo la vista di amministrazione.', modulesHeading: 'Questo accesso comprende:', via: 'tramite {module}',
      heading: 'Che cosa stai approvando',
      data: 'Il supporto potrà accedere ai dati di questo spazio in tutti i moduli attivi, compresi i dati personali di dipendenti e candidati.',
      audited: 'Ogni azione viene registrata nel tuo registro di audit e contrassegnata come azione del supporto.',
      duration: 'L’accesso termina automaticamente dopo {days} giorni.',
      revocable: 'Puoi terminarlo in qualsiasi momento; ha effetto entro un minuto.',
    },
    actions: { approve: 'Approva l’accesso', deny: 'Rifiuta', revoke: 'Termina ora' },
    status: {
      requested: 'In attesa',
      active: 'Attivo',
      denied: 'Rifiutato',
      revoked: 'Terminato',
      expired: 'Scaduto',
      request_expired: 'Richiesta scaduta',
    },
    columns: { supporter: 'Account di supporto', requestedAt: 'Richiesto', status: 'Stato', endedAt: 'Terminato' },
    success: { approved: 'Accesso del supporto approvato.', denied: 'Richiesta rifiutata.', revoked: 'Accesso del supporto terminato.' },
    errors: {
      consentChanged: 'Il testo del consenso è cambiato. Rileggilo prima di approvare.',
      selfApproval: 'L’account richiedente non può approvare la propria richiesta.',
    },
  },
  // Administration › Statutory rules (ADR 0091): the statutory rule catalogue
  // and the workspace's agreements and deviations, moved here from Time's
  // settings with the page.
  statutory: {
    title: 'Norme di legge e accordi',
    intro: 'Le norme di legge si applicano automaticamente e vengono aggiornate a livello centrale. Qui indichi solo dove la tua azienda se ne discosta: ogni deroga richiede una base, ad esempio un contratto collettivo o un accordo aziendale.',
    disclaimer: 'Valori orientativi secondo la legge – non è consulenza legale. I contratti collettivi possono essere più severi.',
    // "Checked, fits us" (issue 713): the one-time confirmation of the statutory defaults.
    confirmation: {
      unchecked: {
        title: 'Non ancora verificato',
        // The short sentence for someone who may read the page but not confirm (a support grant): no picker, no button.
        body: 'lumi parte con le norme di legge predefinite. Se vanno bene per voi, conferma. Se da voi vale un contratto collettivo o un accordo aziendale, crea qui sotto una deroga.',
        confirm: 'Verificato, va bene per noi',
        // The mode picker (issue 780) is shown to someone who can confirm; the tile titles are the settings card's own (statutory.workspace.modeFlexible/modeStrict).
        lead: 'lumi parte con le norme di legge predefinite – orario massimo, pause, riposo. Decidi cosa succede quando una registrazione ne viola una, poi conferma che le norme vanno bene per la vostra azienda.',
        standard: 'Predefinito',
        later: 'Puoi modificare entrambe le cose in qualsiasi momento.',
        agreements: 'Da voi vale un contratto collettivo o un accordo aziendale per cui una regola vale diversamente o non vale affatto? Allora crea qui sotto una {basis} – gli avvisi si regolano su di essa. Una modalità senza avvisi non esiste.',
        agreementsBasis: 'deroga con il suo fondamento',
        flexible: {
          personLabel: 'La persona', personText: 'vede al salvataggio quale regola è violata e di quanto – la registrazione resta.',
          managerLabel: 'La direzione', managerText: 'vede le violazioni della settimana all’approvazione e decide insieme alla persona.',
          recordLabel: 'Il registro', recordText: 'annota ogni violazione – per voi, non contro di voi.',
        },
        strict: {
          personLabel: 'La persona', personText: 'non può salvare una registrazione che viola una regola vincolante – e vede perché. Una pausa mancante viene salvata e mostrata.',
          managerLabel: 'La direzione', managerText: 'all’approvazione vede solo ciò che comunque si crea: pause mancanti e chiusure automatiche.',
          fitLabel: 'Va bene se', fitText: 'le eccezioni da voi non devono verificarsi – ad esempio con i minorenni.',
        },
      },
      // After a save that is not a review, while unconfirmed (issue 990): the next step, in place.
      afterSave: { body: 'Salvato. Le regole sull’orario di lavoro non sono ancora confermate – conferma ora che fanno al caso vostro.', confirm: 'Conferma ora' },
      confirmed: { title: 'Verificato', body: 'Confermato il {date} da {name}: le norme di legge vanno bene per noi.', bodyNoName: 'Confermato il {date}: le norme di legge vanno bene per noi.' },
      ownDeviation: { title: 'Verificato', body: 'Il vostro spazio di lavoro ha deroghe proprie, quindi le norme sono già state esaminate.' },
      error: 'Non è stato possibile salvare la conferma. Riprova.',
    },
    noJurisdictions: 'Non è ancora impostata alcuna giurisdizione: non ci sono persone con una sede di lavoro né una giurisdizione predefinita. Scegline una qui sotto e qui compariranno le norme di legge.',
    jurisdictionEu: 'Direttiva UE',
    jurisdictionDefault: '{name} (predefinita)',
    // Who the number is (issue 990): active employees in Time judged by this law —
    // on a tab that is not the default, only those whose work location is there;
    // on the default's tab, also everyone who falls back to it.
    headcountLine: 'Giurisdizione {country}: queste regole al momento non si applicano a nessuno. | Giurisdizione {country}: queste regole valutano l’orario di lavoro di 1 persona in Tempo che lavora qui. | Giurisdizione {country}: queste regole valutano l’orario di lavoro di {count} persone – tutti i dipendenti attivi in Tempo che lavorano qui.',
    headcountLineDefault: 'Giurisdizione {country}: queste regole al momento non si applicano a nessuno. | Giurisdizione {country}: queste regole valutano l’orario di lavoro di 1 persona in Tempo che lavora qui o rientra nella giurisdizione predefinita. | Giurisdizione {country}: queste regole valutano l’orario di lavoro di {count} persone – tutti i dipendenti attivi in Tempo che lavorano qui o rientrano nella giurisdizione predefinita.',
    fallbackLine: 'Persone senza sede di lavoro, o con una sede non coperta dal catalogo: {count} – per loro vale {country}.',
    createModels: 'Crea i modelli orario di lavoro di questo paese',
    domains: {
      workingTime: 'Orario di lavoro',
      pay: 'Fasce orarie con maggiorazione',
      overtime: 'Straordinario',
      leave: 'Ferie',
    },
    rules: {
      maxDailyHours: 'Orario massimo giornaliero',
      maxWeeklyHours: 'Orario massimo settimanale',
      breaks: 'Pause',
      minDailyRest: 'Riposo giornaliero',
      nightWorkBan: 'Divieto di lavoro notturno',
      minWeeklyRest: 'Riposo settimanale',
      avgWeeklyHours: 'Orario settimanale medio',
      normalDailyHours: 'Orario normale giornaliero',
      normalWeeklyHours: 'Orario normale settimanale',
      nightWindow: 'Periodo notturno per le maggiorazioni',
      nightCoreWindow: 'Fascia notturna centrale per maggiorazioni più alte',
      overtimeThreshold: 'Straordinario a partire da (ore settimanali)',
      overtimeSurcharge: 'Maggiorazioni per straordinario',
      minLeaveDays: 'Ferie annuali minime',
    },
    kinds: {
      collectiveAgreement: 'Contratto collettivo',
      worksAgreement: 'Accordo aziendale',
      authorityPermit: 'Autorizzazione dell’autorità',
      companyPolicy: 'Regolamento aziendale',
    },
    value: {
      hoursUnit: 'h',
      days: '{days} giorni',
      breakStage: '{minutes} min oltre {hours} h',
      weeklyAverage: '{hours} h in media su {weeks} settimane',
      nightWorkBan: 'nessun lavoro tra le {start} e le {end}',
      tierFirst: '{percent} % dalla prima ora di straordinario',
      tierAfter: '{percent} % dopo {hours} ore di straordinario',
      none: 'Nessuna regola',
      switchedOff: 'La regola non si applica (disattivata)',
    },
    status: {
      statutory: 'Di legge',
      noStatutoryRule: 'Nessuna norma di legge',
      infoOnly: 'Solo a titolo informativo',
      deviation: 'Deroga',
      deviationStricter: 'Deroga · più severa',
      deviationLooser: 'Deroga · meno severa',
      deviationMoreFavourable: 'Deroga · più favorevole della legge',
      deviationLessFavourable: 'Deroga · meno favorevole della legge',
      deviationEqual: 'Deroga · uguale alla legge',
      deviationMixed: 'Deroga · in parte più severa, in parte meno',
      deviationMixedFavourable: 'Deroga · in parte più favorevole, in parte meno',
    },
    hint: {
      stricter: 'Più severo della legge: ammesso con qualsiasi base.',
      looser: 'Meno severo della legge: serve come base un contratto collettivo, un accordo aziendale o un’autorizzazione dell’autorità.',
      moreFavourable: 'Più favorevole della legge: ammesso con qualsiasi base.',
      lessFavourable: 'Meno favorevole della legge: serve come base un contratto collettivo, un accordo aziendale o un’autorizzazione dell’autorità.',
      mixed: 'In parte più severo, in parte meno severo della legge: serve come base un contratto collettivo, un accordo aziendale o un’autorizzazione dell’autorità.',
      mixedFavourable: 'In parte più favorevole, in parte meno favorevole della legge: serve come base un contratto collettivo, un accordo aziendale o un’autorizzazione dell’autorità.',
      equal: 'Uguale al valore di legge: non serve una deroga.',
      incomparable: 'Per questa regola non esiste «più severo» o «meno severo»: va bene qualsiasi base.',
      blocked: 'Un regolamento aziendale non può restare al di sotto della legge. Scegli come base un contratto collettivo, un accordo aziendale o un’autorizzazione dell’autorità, oppure un valore almeno pari a quello di legge.',
    },
    table: {
      rule: 'Regola',
      applies: 'Si applica',
      note: 'Nota sul quadro normativo',
      deviate: 'Deroga',
      backToStatute: 'Torna alla legge',
      statutoryWouldBe: 'Per legge sarebbe: {value}',
      statutoryWouldBeNone: 'La legge non prevede alcuna regola qui.',
      basis: 'Base: {name}',
      basisWithClause: 'Base: {name}, {clause}',
      coveredDeviation: 'Con codice contrattuale {code}: {value} ({name})',
      futureDeviation: 'Dal {date}: {value} ({name})',
      fallbackApplies: 'La legge non fissa qui alcuna fascia oraria: vale questa finché un accordo non ne fissa un’altra.',
      fallbackWouldBe: 'La legge non fissa qui alcuna fascia oraria: senza la deroga varrebbe {value}',
      editDeviationOf: 'Modifica la deroga di «{name}»',
      backToStatuteOf: 'Riporta alla legge la deroga di «{name}»',
    },
    notice: {
      fallback: 'Il catalogo delle norme di legge è temporaneamente non disponibile. Viene mostrata la base integrata; le modifiche recenti potrebbero mancare.',
      unjudged: 'Persone a cui al momento non si applica alcuna norma di legge: {count}. Non hanno una sede di lavoro e non è impostata una giurisdizione predefinita: scegline una qui sotto.',
      upcoming: 'Dal {date} la norma di legge «{rule}» cambia in: {value}.',
      upcomingNone: 'Dal {date} la norma di legge «{rule}» non si applica più.',
      upcomingDeviationStays: 'La tua deroga resta in vigore.',
      reviewTitle: 'Da verificare: {rule}',
      review: 'Il valore di legge è cambiato da quando è stata definita questa deroga ({agreement}). La legge ora prevede: {statutory}. La tua deroga: {deviation}.',
      keepDeviation: 'Mantieni la deroga',
    },
    minors: {
      title: 'Minori di 18 anni',
      headcount: 'Persone: {count}',
      headcountNone: 'nessuna al momento',
      hint: 'Alle persone con meno di 18 anni si applicano queste norme di legge a tutela dei minori al posto di quelle generali, automaticamente in base alla data di nascita registrata in Personale. Gli accordi non vi derogano.',
      generalApplies: 'Ancora nessuna regola specifica: fino ad allora vale quella generale.',
      upcoming: 'Dal {date}: {value}',
      upcomingNone: 'Dal {date} questa norma a tutela dei minori non si applica più.',
    },
    form: {
      value: 'Valore in deroga',
      daysUnit: 'giorni',
      stageAfterHours: 'Orario di lavoro oltre (h)',
      stageMinutes: 'Pausa totale (min)',
      tierAfterHours: 'Da ore di straordinario a settimana (h)',
      tierPercent: 'Maggiorazione (%)',
      addStep: 'Aggiungi scaglione',
      removeStep: 'Rimuovi scaglione {row}',
      stageAfterHoursRow: 'Scaglione {row}: orario di lavoro oltre (h)',
      stageMinutesRow: 'Scaglione {row}: pausa totale (min)',
      tierAfterHoursRow: 'Scaglione {row}: da ore di straordinario a settimana (h)',
      tierPercentRow: 'Scaglione {row}: maggiorazione (%)',
      averageHours: 'Ore settimanali in media',
      averageWeeks: 'Periodo di riferimento (settimane)',
      windowStart: 'Inizio',
      windowEnd: 'Fine',
      windowHint: 'Se la fine precede l’inizio, la fascia prosegue oltre la mezzanotte.',
      statutoryIs: 'La legge prevede: {value}',
      comparisonBase: 'Senza una regola di legge vale {value}: la deroga si misura rispetto a questo valore.',
      basis: 'Base',
      basisHint: 'L’accordo su cui si basa la deroga.',
      basisPick: 'Scegli una base…',
      basisNew: 'Crea una nuova base…',
      basisRequired: 'Scegli una base.',
      clause: 'Clausola',
      clauseHint: 'Dove si trova la disposizione, ad es. «art. 4, comma 2». Facoltativo.',
      invalid: {
        hours: 'Indica le ore: più di 0 e al massimo 168.',
        days: 'Indica i giorni: più di 0 e al massimo 366.',
        breakLadder: 'Controlla gli scaglioni: da 1 a 6, crescenti per orario di lavoro (più di 0 fino a 24 h), con una pausa di più di 0 fino a 480 min e mai inferiore a quella dello scaglione precedente.',
        weeklyAverage: 'Controlla i valori: ore più di 0 e al massimo 168, periodo di riferimento da 1 a 104 settimane.',
        timeWindow: 'Indica un orario di inizio e uno di fine; devono essere diversi.',
        percentTiers: 'Controlla gli scaglioni: da 1 a 6, il primo da 0 ore di straordinario, gli altri crescenti; maggiorazione tra 0 e 300 % con al massimo due decimali.',
      },
    },
    agreement: {
      name: 'Nome',
      title: 'Accordi',
      subtitle: 'Contratti collettivi, accordi aziendali, autorizzazioni e regolamenti aziendali: le basi delle tue deroghe.',
      new: 'Nuovo accordo',
      edit: 'Modifica accordo',
      empty: 'Ancora nessun accordo: si applicano ovunque le norme di legge.',
      inactive: 'Attualmente non in vigore',
      migrated: 'Ripreso dalle impostazioni precedenti',
      noDeviations: 'Ancora nessuna deroga. Impostale sopra, sulla regola interessata.',
      needsReview: 'Da verificare',
      kind: 'Tipo di accordo',
      companyPolicyHint: 'Un regolamento aziendale può essere solo più severo o più favorevole della legge.',
      nameHint: 'Ad esempio «CCNL Metalmeccanici» o «Accordo pause 2026».',
      nameRequired: 'Dai un nome all’accordo.',
      reference: 'Numero di riferimento',
      referenceHint: 'Facoltativo, ad es. numero di registro o del provvedimento.',
      jurisdiction: 'Giurisdizione',
      validFrom: 'Valido dal',
      validFromRequired: 'Indica da quando si applica l’accordo.',
      validTo: 'Valido fino al',
      validToHint: 'Lascia vuoto se l’accordo è a tempo indeterminato.',
      validSince: 'valido dal {from}',
      validRange: 'valido dal {from} al {to}',
      scope: 'Si applica a',
      scopeAll: 'tutte le persone di questa giurisdizione',
      scopeCovered: 'solo le persone vincolate dal contratto collettivo',
      scopeCoveredCode: 'solo codice contrattuale {code}',
      coverageCode: 'Codice contrattuale',
      coverageCodeHint: 'Il codice si imposta nel contratto di lavoro della persona in Personale. L’accordo si applica solo alle persone con esattamente questo codice.',
      deleteTitle: 'Eliminare «{name}»?',
      deleteConfirm: 'Eliminando l’accordo si eliminano anche le sue deroghe (numero: {count}). Per quelle regole tornerà a valere la legge.',
      deleteConfirmEmpty: 'L’accordo non contiene deroghe; le regole in vigore non cambiano.',
      editDeviation: 'Modifica deroga: {rule}',
      removeDeviation: 'Torna alla legge: {rule}',
    },
    backConfirm: {
      title: '«{rule}»: tornare alla legge?',
      body: 'La deroga verrà rimossa. Tornerà a valere il valore di legge: {value}.',
      bodyNone: 'La deroga verrà rimossa. La legge non prevede alcuna regola qui: dopo non ne varrà nessuna.',
      bodyFallback: 'La deroga verrà rimossa. La legge non prevede alcuna regola qui: dopo tornerà a valere {value}.',
    },
    workspace: {
      title: 'Impostazioni dello spazio di lavoro',
      defaultJurisdiction: 'Giurisdizione predefinita',
      defaultJurisdictionHint: 'Si applica alle persone senza sede di lavoro o con una sede non coperta dal catalogo.',
      noDefault: 'Nessuna predefinita',
      mode: 'Quando una registrazione viola una regola',
      modeFlexible: 'Avvisa e registra',
      modeFlexibleHint: 'La registrazione viene salvata. La violazione viene mostrata e annotata.',
      modeStrict: 'Blocca la registrazione',
      modeStrictHint: 'Una registrazione che viola una regola vincolante non può essere salvata.',
      originSignup: 'Ripreso dal paese indicato dalla tua azienda alla registrazione: {country}.',
      originFallbackPrevious: 'Finché il paese indicato dalla tua azienda alla registrazione non è noto e presente nel catalogo, valgono le regole di {current}, quelle con cui questo spazio di lavoro è stato valutato finora.',
      originFallbackUnknown: 'Il paese della tua azienda non è ancora noto, quindi vale il minimo UE finché qualcuno non sceglie qui il paese.',
      originFallbackUncovered: 'Alla registrazione la tua azienda ha indicato {country}. Il catalogo non contiene ancora regole per questo paese, quindi vale il minimo UE.',
      originFallbackCovered: 'Alla registrazione la tua azienda ha indicato {country}, le cui regole ora sono nel catalogo. Sceglilo qui per applicarle: fino ad allora vale il minimo UE.',
    },
    toast: {
      settingsSaved: 'Impostazioni salvate',
      deviationSaved: 'Deroga salvata',
      deviationConfirmed: 'Deroga confermata',
      backToStatute: 'Deroga rimossa: torna a valere la legge',
      agreementSaved: 'Accordo salvato',
      agreementDeleted: 'Accordo eliminato',
      modelsCreated: 'Modelli orario di lavoro creati: {count}',
      modelsExist: 'I modelli orario di lavoro di questo paese esistono già.',
    },
    errors: {
      rival: '«{name}» stabilisce già questa regola per le stesse persone in un periodo sovrapposto.',
      validToBeforeFrom: 'La fine della validità non può precedere l’inizio.',
      coverageCodeRequired: 'Indica il codice contrattuale a cui si applica l’accordo.',
      invalidValue: 'Il valore non è valido per questa regola. Controllalo.',
      jurisdictionUnknown: 'Questa giurisdizione non è presente nel catalogo delle norme di legge.',
      dateInvalid: 'Indica una data valida.',
      labelInvalid: 'Controlla i campi di testo: il nome è obbligatorio e nessun campo può superare i 160 caratteri.',
      noModelPresets: 'Non ci sono modelli orario di lavoro predisposti per questo paese.',
      kindInvalid: 'Scegli il tipo di accordo dall’elenco.',
      modeInvalid: 'Scegli cosa succede quando una registrazione viola una regola.',
      ruleUnknown: 'Questa versione dell’app non conosce questa regola. Ricarica la pagina.',
      ruleInfoOnly: 'Questa regola è mostrata solo a titolo informativo: non è possibile derogarvi.',
    },
    // The workspace page around the section (Administration › Statutory rules):
    // a workspace without Time, and a viewer time-api does not admit.
    page: {
      timeInactiveTitle: 'Tempo non è attivo in questo spazio di lavoro',
      timeInactive: 'Le norme di legge si applicano al tempo di lavoro registrato in Tempo. Quando Tempo farà parte di questo spazio di lavoro, qui indicherai dove la tua azienda se ne discosta.',
      noAccess: 'Non puoi gestire le norme di legge di questo spazio di lavoro. Possono farlo il proprietario dello spazio di lavoro, l’amministrazione suite e i membri di Tempo autorizzati a gestire la conformità.',
    },
  },
  // Administration › Training occupations (ADR 0092).
  trainingOccupations: {
    title: 'Professioni di formazione',
    columns: {
      occupation: 'Professione di formazione',
      duration: 'Durata',
      regulation: 'Regolamento di formazione',
      apprentices: 'Apprendisti',
    },
    duration: '{count} mesi',
    regulationIssued: 'del {date}',
    regulationValidFrom: 'in vigore dal {date}',
    areas: {
      IH: 'Industria e commercio (IHK)',
      Hw: 'Artigianato (HWK)',
      oeD: 'Servizio pubblico',
      Lw: 'Agricoltura',
      FB: 'Libere professioni',
      Hausw: 'Economia domestica',
      See: 'Navigazione marittima',
    },
    branches: {
      specialisations: 'Indirizzi',
      focuses: 'Aree di approfondimento',
      any: 'Indirizzi / aree di approfondimento',
    },
    requirements: {
      onWall: 'Posizioni del regolamento di formazione sul muro delle competenze: {count}',
      version: 'regolamento del {date}',
      none: 'Le posizioni del regolamento di formazione non sono ancora disponibili. Compariranno sul muro delle competenze non appena il gestore della piattaforma le avrà importate.',
      versions: 'Gli apprendisti si formano secondo {count} versioni del regolamento: per ciascuno vale la versione in vigore all’inizio della formazione.',
    },
    state: {
      notSelectable: 'Non più selezionabile',
      notSelectableHint: 'Il gestore della piattaforma non offre più questa professione per nuove selezioni. Il tuo spazio di lavoro la mantiene insieme ai suoi apprendisti, ma una volta rimossa non potrà più essere aggiunta.',
      withdrawn: 'Riconoscimento revocato',
      withdrawnHint: 'Il riconoscimento statale di questa professione è stato abrogato, oppure non figura più nell’elenco delle professioni di formazione riconosciute. Gli apprendisti in corso completano la formazione; non può più essere aggiunta.',
      unknown: 'Non presente nel catalogo',
      unknownHint: 'Questa voce è stata digitata prima che esistesse il catalogo e non corrisponde a nessuna delle sue professioni. Può solo essere rimossa: aggiungi al suo posto la professione corrispondente dal catalogo.',
    },
    offered: {
      title: 'La nostra offerta',
      intro: 'Le professioni di formazione riconosciute in cui la tua azienda forma. Solo queste possono essere scelte per un apprendista.',
      emptyTitle: 'Nessuna professione di formazione ancora in offerta',
      empty: 'Scegli dal catalogo qui sotto le professioni in cui la tua azienda forma. Poi potrai assegnarle ai tuoi apprendisti.',
      browse: 'Scegli dal catalogo',
      remove: 'Rimuovi',
      removeNamed: 'Rimuovi {title} dall’offerta',
    },
    catalogue: {
      title: 'Aggiungi dal catalogo',
      intro: 'Le professioni di formazione riconosciute in Germania che il tuo spazio di lavoro non offre ancora. Il catalogo viene mantenuto aggiornato a livello centrale.',
      unavailableTitle: 'Il catalogo non è raggiungibile in questo momento',
      unavailable: 'La tua offerta qui sopra è mostrata in base a quanto salvato da questo spazio di lavoro. Sarà di nuovo possibile aggiungere professioni non appena il catalogo tornerà disponibile.',
      allOffered: 'Il tuo spazio di lavoro offre già tutte le professioni del catalogo.',
      searchPlaceholder: 'Titolo o indirizzo',
      areaLabel: 'Settore',
      areaAll: 'Tutti i settori',
      count: 'Professioni trovate: {shown} di {total}',
      noMatches: 'Nessuna professione corrisponde alla tua ricerca.',
      resetFilters: 'Azzera la ricerca',
      showMore: 'Mostra altro',
      add: 'Aggiungi',
      addNamed: 'Aggiungi {title} all’offerta',
    },
    removeConfirm: {
      title: 'Rimuovere «{title}» dall’offerta?',
      apprentices: 'Apprendisti attualmente assegnati a questa professione: {count}. Mantengono la loro professione e completano la formazione: semplicemente non potrà più essere scelta per nuovi apprendisti.',
      final: 'Una volta rimossa, questa professione non potrà più essere aggiunta.',
      confirm: 'Rimuovi dall’offerta',
    },
    toast: {
      added: '«{title}» fa ora parte della tua offerta',
      removed: '«{title}» non è più in offerta',
    },
    errors: {
      notOfferable: 'Non è stato possibile aggiungere «{title}»: nel frattempo la professione è stata disattivata o revocata. L’elenco è stato aggiornato.',
      catalogueUnavailable: 'Il catalogo non è raggiungibile in questo momento, quindi non è possibile aggiungere nulla. Riprova più tardi.',
    },
    page: {
      moduleInactiveTitle: 'Formazione non è attivo in questo spazio di lavoro',
      moduleInactive: 'Le professioni di formazione sono offerte per gli apprendisti gestiti nel modulo Formazione. Quando farà parte di questo spazio di lavoro, qui sceglierai in quali professioni la tua azienda forma.',
      noAccess: 'Non puoi gestire le professioni di formazione di questo spazio di lavoro. Possono farlo il proprietario dello spazio di lavoro, l’amministrazione suite e i membri del modulo Formazione autorizzati a gestirlo.',
    },
  },
};
